import Nr, { useMemo as ti } from "react";
function ui(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
function ri(u) {
  if (Object.prototype.hasOwnProperty.call(u, "__esModule")) return u;
  var E = u.default;
  if (typeof E == "function") {
    var v = function l() {
      return this instanceof l ? Reflect.construct(E, arguments, this.constructor) : E.apply(this, arguments);
    };
    v.prototype = E.prototype;
  } else v = {};
  return Object.defineProperty(v, "__esModule", { value: !0 }), Object.keys(u).forEach(function(l) {
    var d = Object.getOwnPropertyDescriptor(u, l);
    Object.defineProperty(v, l, d.get ? d : {
      enumerable: !0,
      get: function() {
        return u[l];
      }
    });
  }), v;
}
var Ye = { exports: {} }, Fe = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var mt, mu;
function Cr() {
  if (mu) return mt;
  mu = 1;
  var u = Object.getOwnPropertySymbols, E = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
  function l(h) {
    if (h == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(h);
  }
  function d() {
    try {
      if (!Object.assign)
        return !1;
      var h = new String("abc");
      if (h[5] = "de", Object.getOwnPropertyNames(h)[0] === "5")
        return !1;
      for (var a = {}, f = 0; f < 10; f++)
        a["_" + String.fromCharCode(f)] = f;
      var p = Object.getOwnPropertyNames(a).map(function(r) {
        return a[r];
      });
      if (p.join("") !== "0123456789")
        return !1;
      var i = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(r) {
        i[r] = r;
      }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return mt = d() ? Object.assign : function(h, a) {
    for (var f, p = l(h), i, r = 1; r < arguments.length; r++) {
      f = Object(arguments[r]);
      for (var c in f)
        E.call(f, c) && (p[c] = f[c]);
      if (u) {
        i = u(f);
        for (var e = 0; e < i.length; e++)
          v.call(f, i[e]) && (p[i[e]] = f[i[e]]);
      }
    }
    return p;
  }, mt;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gu;
function ii() {
  if (gu) return Fe;
  gu = 1, Cr();
  var u = Nr, E = 60103;
  if (Fe.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var v = Symbol.for;
    E = v("react.element"), Fe.Fragment = v("react.fragment");
  }
  var l = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = Object.prototype.hasOwnProperty, h = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(f, p, i) {
    var r, c = {}, e = null, t = null;
    i !== void 0 && (e = "" + i), p.key !== void 0 && (e = "" + p.key), p.ref !== void 0 && (t = p.ref);
    for (r in p) d.call(p, r) && !h.hasOwnProperty(r) && (c[r] = p[r]);
    if (f && f.defaultProps) for (r in p = f.defaultProps, p) c[r] === void 0 && (c[r] = p[r]);
    return { $$typeof: E, type: f, key: e, ref: t, props: c, _owner: l.current };
  }
  return Fe.jsx = a, Fe.jsxs = a, Fe;
}
var gt = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yu;
function ni() {
  return yu || (yu = 1, function(u) {
    process.env.NODE_ENV !== "production" && function() {
      var E = Nr, v = Cr(), l = 60103, d = 60106;
      u.Fragment = 60107;
      var h = 60108, a = 60114, f = 60109, p = 60110, i = 60112, r = 60113, c = 60120, e = 60115, t = 60116, o = 60121, b = 60122, y = 60117, n = 60129, m = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var g = Symbol.for;
        l = g("react.element"), d = g("react.portal"), u.Fragment = g("react.fragment"), h = g("react.strict_mode"), a = g("react.profiler"), f = g("react.provider"), p = g("react.context"), i = g("react.forward_ref"), r = g("react.suspense"), c = g("react.suspense_list"), e = g("react.memo"), t = g("react.lazy"), o = g("react.block"), b = g("react.server.block"), y = g("react.fundamental"), g("react.scope"), g("react.opaque.id"), n = g("react.debug_trace_mode"), g("react.offscreen"), m = g("react.legacy_hidden");
      }
      var x = typeof Symbol == "function" && Symbol.iterator, s = "@@iterator";
      function w(T) {
        if (T === null || typeof T != "object")
          return null;
        var D = x && T[x] || T[s];
        return typeof D == "function" ? D : null;
      }
      var S = E.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function A(T) {
        {
          for (var D = arguments.length, j = new Array(D > 1 ? D - 1 : 0), U = 1; U < D; U++)
            j[U - 1] = arguments[U];
          P("error", T, j);
        }
      }
      function P(T, D, j) {
        {
          var U = S.ReactDebugCurrentFrame, K = U.getStackAddendum();
          K !== "" && (D += "%s", j = j.concat([K]));
          var Z = j.map(function(W) {
            return "" + W;
          });
          Z.unshift("Warning: " + D), Function.prototype.apply.call(console[T], console, Z);
        }
      }
      var R = !1;
      function _(T) {
        return !!(typeof T == "string" || typeof T == "function" || T === u.Fragment || T === a || T === n || T === h || T === r || T === c || T === m || R || typeof T == "object" && T !== null && (T.$$typeof === t || T.$$typeof === e || T.$$typeof === f || T.$$typeof === p || T.$$typeof === i || T.$$typeof === y || T.$$typeof === o || T[0] === b));
      }
      function O(T, D, j) {
        var U = D.displayName || D.name || "";
        return T.displayName || (U !== "" ? j + "(" + U + ")" : j);
      }
      function q(T) {
        return T.displayName || "Context";
      }
      function M(T) {
        if (T == null)
          return null;
        if (typeof T.tag == "number" && A("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof T == "function")
          return T.displayName || T.name || null;
        if (typeof T == "string")
          return T;
        switch (T) {
          case u.Fragment:
            return "Fragment";
          case d:
            return "Portal";
          case a:
            return "Profiler";
          case h:
            return "StrictMode";
          case r:
            return "Suspense";
          case c:
            return "SuspenseList";
        }
        if (typeof T == "object")
          switch (T.$$typeof) {
            case p:
              var D = T;
              return q(D) + ".Consumer";
            case f:
              var j = T;
              return q(j._context) + ".Provider";
            case i:
              return O(T, T.render, "ForwardRef");
            case e:
              return M(T.type);
            case o:
              return M(T._render);
            case t: {
              var U = T, K = U._payload, Z = U._init;
              try {
                return M(Z(K));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var N = 0, V, z, J, ee, te, oe, Ne;
      function B() {
      }
      B.__reactDisabledLog = !0;
      function ce() {
        {
          if (N === 0) {
            V = console.log, z = console.info, J = console.warn, ee = console.error, te = console.group, oe = console.groupCollapsed, Ne = console.groupEnd;
            var T = {
              configurable: !0,
              enumerable: !0,
              value: B,
              writable: !0
            };
            Object.defineProperties(console, {
              info: T,
              log: T,
              warn: T,
              error: T,
              group: T,
              groupCollapsed: T,
              groupEnd: T
            });
          }
          N++;
        }
      }
      function ve() {
        {
          if (N--, N === 0) {
            var T = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: v({}, T, {
                value: V
              }),
              info: v({}, T, {
                value: z
              }),
              warn: v({}, T, {
                value: J
              }),
              error: v({}, T, {
                value: ee
              }),
              group: v({}, T, {
                value: te
              }),
              groupCollapsed: v({}, T, {
                value: oe
              }),
              groupEnd: v({}, T, {
                value: Ne
              })
            });
          }
          N < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Ce = S.ReactCurrentDispatcher, xe;
      function Re(T, D, j) {
        {
          if (xe === void 0)
            try {
              throw Error();
            } catch (K) {
              var U = K.stack.trim().match(/\n( *(at )?)/);
              xe = U && U[1] || "";
            }
          return `
` + xe + T;
        }
      }
      var De = !1, we;
      {
        var C = typeof WeakMap == "function" ? WeakMap : Map;
        we = new C();
      }
      function L(T, D) {
        if (!T || De)
          return "";
        {
          var j = we.get(T);
          if (j !== void 0)
            return j;
        }
        var U;
        De = !0;
        var K = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Z;
        Z = Ce.current, Ce.current = null, ce();
        try {
          if (D) {
            var W = function() {
              throw Error();
            };
            if (Object.defineProperty(W.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(W, []);
              } catch (Se) {
                U = Se;
              }
              Reflect.construct(T, [], W);
            } else {
              try {
                W.call();
              } catch (Se) {
                U = Se;
              }
              T.call(W.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Se) {
              U = Se;
            }
            T();
          }
        } catch (Se) {
          if (Se && U && typeof Se.stack == "string") {
            for (var $ = Se.stack.split(`
`), ae = U.stack.split(`
`), re = $.length - 1, ie = ae.length - 1; re >= 1 && ie >= 0 && $[re] !== ae[ie]; )
              ie--;
            for (; re >= 1 && ie >= 0; re--, ie--)
              if ($[re] !== ae[ie]) {
                if (re !== 1 || ie !== 1)
                  do
                    if (re--, ie--, ie < 0 || $[re] !== ae[ie]) {
                      var Ee = `
` + $[re].replace(" at new ", " at ");
                      return typeof T == "function" && we.set(T, Ee), Ee;
                    }
                  while (re >= 1 && ie >= 0);
                break;
              }
          }
        } finally {
          De = !1, Ce.current = Z, ve(), Error.prepareStackTrace = K;
        }
        var He = T ? T.displayName || T.name : "", bu = He ? Re(He) : "";
        return typeof T == "function" && we.set(T, bu), bu;
      }
      function I(T, D, j) {
        return L(T, !1);
      }
      function H(T) {
        var D = T.prototype;
        return !!(D && D.isReactComponent);
      }
      function ue(T, D, j) {
        if (T == null)
          return "";
        if (typeof T == "function")
          return L(T, H(T));
        if (typeof T == "string")
          return Re(T);
        switch (T) {
          case r:
            return Re("Suspense");
          case c:
            return Re("SuspenseList");
        }
        if (typeof T == "object")
          switch (T.$$typeof) {
            case i:
              return I(T.render);
            case e:
              return ue(T.type, D, j);
            case o:
              return I(T._render);
            case t: {
              var U = T, K = U._payload, Z = U._init;
              try {
                return ue(Z(K), D, j);
              } catch {
              }
            }
          }
        return "";
      }
      var ne = {}, lt = S.ReactDebugCurrentFrame;
      function Ve(T) {
        if (T) {
          var D = T._owner, j = ue(T.type, T._source, D ? D.type : null);
          lt.setExtraStackFrame(j);
        } else
          lt.setExtraStackFrame(null);
      }
      function Q(T, D, j, U, K) {
        {
          var Z = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var W in T)
            if (Z(T, W)) {
              var $ = void 0;
              try {
                if (typeof T[W] != "function") {
                  var ae = Error((U || "React class") + ": " + j + " type `" + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof T[W] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ae.name = "Invariant Violation", ae;
                }
                $ = T[W](D, W, U, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (re) {
                $ = re;
              }
              $ && !($ instanceof Error) && (Ve(K), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", U || "React class", j, W, typeof $), Ve(null)), $ instanceof Error && !($.message in ne) && (ne[$.message] = !0, Ve(K), A("Failed %s type: %s", j, $.message), Ve(null));
            }
        }
      }
      var G = S.ReactCurrentOwner, qe = Object.prototype.hasOwnProperty, X = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Y, ge;
      function fe(T) {
        if (qe.call(T, "ref")) {
          var D = Object.getOwnPropertyDescriptor(T, "ref").get;
          if (D && D.isReactWarning)
            return !1;
        }
        return T.ref !== void 0;
      }
      function le(T) {
        if (qe.call(T, "key")) {
          var D = Object.getOwnPropertyDescriptor(T, "key").get;
          if (D && D.isReactWarning)
            return !1;
        }
        return T.key !== void 0;
      }
      function ft(T, D) {
        typeof T.ref == "string" && G.current;
      }
      function We(T, D) {
        {
          var j = function() {
            Y || (Y = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
          };
          j.isReactWarning = !0, Object.defineProperty(T, "key", {
            get: j,
            configurable: !0
          });
        }
      }
      function dt(T, D) {
        {
          var j = function() {
            ge || (ge = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
          };
          j.isReactWarning = !0, Object.defineProperty(T, "ref", {
            get: j,
            configurable: !0
          });
        }
      }
      var $r = function(T, D, j, U, K, Z, W) {
        var $ = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: l,
          // Built-in properties that belong on the element
          type: T,
          key: D,
          ref: j,
          props: W,
          // Record the component responsible for creating this element.
          _owner: Z
        };
        return $._store = {}, Object.defineProperty($._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty($, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: U
        }), Object.defineProperty($, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: K
        }), Object.freeze && (Object.freeze($.props), Object.freeze($)), $;
      };
      function Gr(T, D, j, U, K) {
        {
          var Z, W = {}, $ = null, ae = null;
          j !== void 0 && ($ = "" + j), le(D) && ($ = "" + D.key), fe(D) && (ae = D.ref, ft(D, K));
          for (Z in D)
            qe.call(D, Z) && !X.hasOwnProperty(Z) && (W[Z] = D[Z]);
          if (T && T.defaultProps) {
            var re = T.defaultProps;
            for (Z in re)
              W[Z] === void 0 && (W[Z] = re[Z]);
          }
          if ($ || ae) {
            var ie = typeof T == "function" ? T.displayName || T.name || "Unknown" : T;
            $ && We(W, ie), ae && dt(W, ie);
          }
          return $r(T, $, ae, K, U, G.current, W);
        }
      }
      var ht = S.ReactCurrentOwner, cu = S.ReactDebugCurrentFrame;
      function Ue(T) {
        if (T) {
          var D = T._owner, j = ue(T.type, T._source, D ? D.type : null);
          cu.setExtraStackFrame(j);
        } else
          cu.setExtraStackFrame(null);
      }
      var pt;
      pt = !1;
      function bt(T) {
        return typeof T == "object" && T !== null && T.$$typeof === l;
      }
      function lu() {
        {
          if (ht.current) {
            var T = M(ht.current.type);
            if (T)
              return `

Check the render method of \`` + T + "`.";
          }
          return "";
        }
      }
      function Wr(T) {
        return "";
      }
      var fu = {};
      function Yr(T) {
        {
          var D = lu();
          if (!D) {
            var j = typeof T == "string" ? T : T.displayName || T.name;
            j && (D = `

Check the top-level render call using <` + j + ">.");
          }
          return D;
        }
      }
      function du(T, D) {
        {
          if (!T._store || T._store.validated || T.key != null)
            return;
          T._store.validated = !0;
          var j = Yr(D);
          if (fu[j])
            return;
          fu[j] = !0;
          var U = "";
          T && T._owner && T._owner !== ht.current && (U = " It was passed a child from " + M(T._owner.type) + "."), Ue(T), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, U), Ue(null);
        }
      }
      function hu(T, D) {
        {
          if (typeof T != "object")
            return;
          if (Array.isArray(T))
            for (var j = 0; j < T.length; j++) {
              var U = T[j];
              bt(U) && du(U, D);
            }
          else if (bt(T))
            T._store && (T._store.validated = !0);
          else if (T) {
            var K = w(T);
            if (typeof K == "function" && K !== T.entries)
              for (var Z = K.call(T), W; !(W = Z.next()).done; )
                bt(W.value) && du(W.value, D);
          }
        }
      }
      function Jr(T) {
        {
          var D = T.type;
          if (D == null || typeof D == "string")
            return;
          var j;
          if (typeof D == "function")
            j = D.propTypes;
          else if (typeof D == "object" && (D.$$typeof === i || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          D.$$typeof === e))
            j = D.propTypes;
          else
            return;
          if (j) {
            var U = M(D);
            Q(j, T.props, "prop", U, T);
          } else if (D.PropTypes !== void 0 && !pt) {
            pt = !0;
            var K = M(D);
            A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", K || "Unknown");
          }
          typeof D.getDefaultProps == "function" && !D.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Xr(T) {
        {
          for (var D = Object.keys(T.props), j = 0; j < D.length; j++) {
            var U = D[j];
            if (U !== "children" && U !== "key") {
              Ue(T), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", U), Ue(null);
              break;
            }
          }
          T.ref !== null && (Ue(T), A("Invalid attribute `ref` supplied to `React.Fragment`."), Ue(null));
        }
      }
      function pu(T, D, j, U, K, Z) {
        {
          var W = _(T);
          if (!W) {
            var $ = "";
            (T === void 0 || typeof T == "object" && T !== null && Object.keys(T).length === 0) && ($ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ae = Wr();
            ae ? $ += ae : $ += lu();
            var re;
            T === null ? re = "null" : Array.isArray(T) ? re = "array" : T !== void 0 && T.$$typeof === l ? (re = "<" + (M(T.type) || "Unknown") + " />", $ = " Did you accidentally export a JSX literal instead of a component?") : re = typeof T, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", re, $);
          }
          var ie = Gr(T, D, j, K, Z);
          if (ie == null)
            return ie;
          if (W) {
            var Ee = D.children;
            if (Ee !== void 0)
              if (U)
                if (Array.isArray(Ee)) {
                  for (var He = 0; He < Ee.length; He++)
                    hu(Ee[He], T);
                  Object.freeze && Object.freeze(Ee);
                } else
                  A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                hu(Ee, T);
          }
          return T === u.Fragment ? Xr(ie) : Jr(ie), ie;
        }
      }
      function Qr(T, D, j) {
        return pu(T, D, j, !0);
      }
      function Zr(T, D, j) {
        return pu(T, D, j, !1);
      }
      var Kr = Zr, ei = Qr;
      u.jsx = Kr, u.jsxs = ei;
    }();
  }(gt)), gt;
}
var vu;
function ai() {
  return vu || (vu = 1, process.env.NODE_ENV === "production" ? Ye.exports = ii() : Ye.exports = ni()), Ye.exports;
}
var k = ai(), de = {}, he = {}, yt = {}, pe = {}, Je = {}, xu;
function si() {
  return xu || (xu = 1, Object.defineProperty(Je, "__esModule", { value: !0 }), Je.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Je;
}
var Xe = {}, wu;
function oi() {
  return wu || (wu = 1, Object.defineProperty(Xe, "__esModule", { value: !0 }), Xe.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(u) {
      return u.charCodeAt(0);
    })
  )), Xe;
}
var vt = {}, Eu;
function Su() {
  return Eu || (Eu = 1, function(u) {
    var E;
    Object.defineProperty(u, "__esModule", { value: !0 }), u.replaceCodePoint = u.fromCodePoint = void 0;
    var v = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    u.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (E = String.fromCodePoint) !== null && E !== void 0 ? E : function(h) {
      var a = "";
      return h > 65535 && (h -= 65536, a += String.fromCharCode(h >>> 10 & 1023 | 55296), h = 56320 | h & 1023), a += String.fromCharCode(h), a;
    };
    function l(h) {
      var a;
      return h >= 55296 && h <= 57343 || h > 1114111 ? 65533 : (a = v.get(h)) !== null && a !== void 0 ? a : h;
    }
    u.replaceCodePoint = l;
    function d(h) {
      return (0, u.fromCodePoint)(l(h));
    }
    u.default = d;
  }(vt)), vt;
}
var Tu;
function rt() {
  return Tu || (Tu = 1, function(u) {
    var E = pe && pe.__createBinding || (Object.create ? function(_, O, q, M) {
      M === void 0 && (M = q);
      var N = Object.getOwnPropertyDescriptor(O, q);
      (!N || ("get" in N ? !O.__esModule : N.writable || N.configurable)) && (N = { enumerable: !0, get: function() {
        return O[q];
      } }), Object.defineProperty(_, M, N);
    } : function(_, O, q, M) {
      M === void 0 && (M = q), _[M] = O[q];
    }), v = pe && pe.__setModuleDefault || (Object.create ? function(_, O) {
      Object.defineProperty(_, "default", { enumerable: !0, value: O });
    } : function(_, O) {
      _.default = O;
    }), l = pe && pe.__importStar || function(_) {
      if (_ && _.__esModule) return _;
      var O = {};
      if (_ != null) for (var q in _) q !== "default" && Object.prototype.hasOwnProperty.call(_, q) && E(O, _, q);
      return v(O, _), O;
    }, d = pe && pe.__importDefault || function(_) {
      return _ && _.__esModule ? _ : { default: _ };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXML = u.decodeHTMLStrict = u.decodeHTMLAttribute = u.decodeHTML = u.determineBranch = u.EntityDecoder = u.DecodingMode = u.BinTrieFlags = u.fromCodePoint = u.replaceCodePoint = u.decodeCodePoint = u.xmlDecodeTree = u.htmlDecodeTree = void 0;
    var h = d(/* @__PURE__ */ si());
    u.htmlDecodeTree = h.default;
    var a = d(/* @__PURE__ */ oi());
    u.xmlDecodeTree = a.default;
    var f = l(/* @__PURE__ */ Su());
    u.decodeCodePoint = f.default;
    var p = /* @__PURE__ */ Su();
    Object.defineProperty(u, "replaceCodePoint", { enumerable: !0, get: function() {
      return p.replaceCodePoint;
    } }), Object.defineProperty(u, "fromCodePoint", { enumerable: !0, get: function() {
      return p.fromCodePoint;
    } });
    var i;
    (function(_) {
      _[_.NUM = 35] = "NUM", _[_.SEMI = 59] = "SEMI", _[_.EQUALS = 61] = "EQUALS", _[_.ZERO = 48] = "ZERO", _[_.NINE = 57] = "NINE", _[_.LOWER_A = 97] = "LOWER_A", _[_.LOWER_F = 102] = "LOWER_F", _[_.LOWER_X = 120] = "LOWER_X", _[_.LOWER_Z = 122] = "LOWER_Z", _[_.UPPER_A = 65] = "UPPER_A", _[_.UPPER_F = 70] = "UPPER_F", _[_.UPPER_Z = 90] = "UPPER_Z";
    })(i || (i = {}));
    var r = 32, c;
    (function(_) {
      _[_.VALUE_LENGTH = 49152] = "VALUE_LENGTH", _[_.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", _[_.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(c = u.BinTrieFlags || (u.BinTrieFlags = {}));
    function e(_) {
      return _ >= i.ZERO && _ <= i.NINE;
    }
    function t(_) {
      return _ >= i.UPPER_A && _ <= i.UPPER_F || _ >= i.LOWER_A && _ <= i.LOWER_F;
    }
    function o(_) {
      return _ >= i.UPPER_A && _ <= i.UPPER_Z || _ >= i.LOWER_A && _ <= i.LOWER_Z || e(_);
    }
    function b(_) {
      return _ === i.EQUALS || o(_);
    }
    var y;
    (function(_) {
      _[_.EntityStart = 0] = "EntityStart", _[_.NumericStart = 1] = "NumericStart", _[_.NumericDecimal = 2] = "NumericDecimal", _[_.NumericHex = 3] = "NumericHex", _[_.NamedEntity = 4] = "NamedEntity";
    })(y || (y = {}));
    var n;
    (function(_) {
      _[_.Legacy = 0] = "Legacy", _[_.Strict = 1] = "Strict", _[_.Attribute = 2] = "Attribute";
    })(n = u.DecodingMode || (u.DecodingMode = {}));
    var m = (
      /** @class */
      function() {
        function _(O, q, M) {
          this.decodeTree = O, this.emitCodePoint = q, this.errors = M, this.state = y.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = n.Strict;
        }
        return _.prototype.startEntity = function(O) {
          this.decodeMode = O, this.state = y.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, _.prototype.write = function(O, q) {
          switch (this.state) {
            case y.EntityStart:
              return O.charCodeAt(q) === i.NUM ? (this.state = y.NumericStart, this.consumed += 1, this.stateNumericStart(O, q + 1)) : (this.state = y.NamedEntity, this.stateNamedEntity(O, q));
            case y.NumericStart:
              return this.stateNumericStart(O, q);
            case y.NumericDecimal:
              return this.stateNumericDecimal(O, q);
            case y.NumericHex:
              return this.stateNumericHex(O, q);
            case y.NamedEntity:
              return this.stateNamedEntity(O, q);
          }
        }, _.prototype.stateNumericStart = function(O, q) {
          return q >= O.length ? -1 : (O.charCodeAt(q) | r) === i.LOWER_X ? (this.state = y.NumericHex, this.consumed += 1, this.stateNumericHex(O, q + 1)) : (this.state = y.NumericDecimal, this.stateNumericDecimal(O, q));
        }, _.prototype.addToNumericResult = function(O, q, M, N) {
          if (q !== M) {
            var V = M - q;
            this.result = this.result * Math.pow(N, V) + parseInt(O.substr(q, V), N), this.consumed += V;
          }
        }, _.prototype.stateNumericHex = function(O, q) {
          for (var M = q; q < O.length; ) {
            var N = O.charCodeAt(q);
            if (e(N) || t(N))
              q += 1;
            else
              return this.addToNumericResult(O, M, q, 16), this.emitNumericEntity(N, 3);
          }
          return this.addToNumericResult(O, M, q, 16), -1;
        }, _.prototype.stateNumericDecimal = function(O, q) {
          for (var M = q; q < O.length; ) {
            var N = O.charCodeAt(q);
            if (e(N))
              q += 1;
            else
              return this.addToNumericResult(O, M, q, 10), this.emitNumericEntity(N, 2);
          }
          return this.addToNumericResult(O, M, q, 10), -1;
        }, _.prototype.emitNumericEntity = function(O, q) {
          var M;
          if (this.consumed <= q)
            return (M = this.errors) === null || M === void 0 || M.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (O === i.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === n.Strict)
            return 0;
          return this.emitCodePoint((0, f.replaceCodePoint)(this.result), this.consumed), this.errors && (O !== i.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, _.prototype.stateNamedEntity = function(O, q) {
          for (var M = this.decodeTree, N = M[this.treeIndex], V = (N & c.VALUE_LENGTH) >> 14; q < O.length; q++, this.excess++) {
            var z = O.charCodeAt(q);
            if (this.treeIndex = x(M, N, this.treeIndex + Math.max(1, V), z), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === n.Attribute && // We shouldn't have consumed any characters after the entity,
              (V === 0 || // And there should be no invalid characters.
              b(z)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (N = M[this.treeIndex], V = (N & c.VALUE_LENGTH) >> 14, V !== 0) {
              if (z === i.SEMI)
                return this.emitNamedEntityData(this.treeIndex, V, this.consumed + this.excess);
              this.decodeMode !== n.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, _.prototype.emitNotTerminatedNamedEntity = function() {
          var O, q = this, M = q.result, N = q.decodeTree, V = (N[M] & c.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(M, V, this.consumed), (O = this.errors) === null || O === void 0 || O.missingSemicolonAfterCharacterReference(), this.consumed;
        }, _.prototype.emitNamedEntityData = function(O, q, M) {
          var N = this.decodeTree;
          return this.emitCodePoint(q === 1 ? N[O] & ~c.VALUE_LENGTH : N[O + 1], M), q === 3 && this.emitCodePoint(N[O + 2], M), M;
        }, _.prototype.end = function() {
          var O;
          switch (this.state) {
            case y.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== n.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case y.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case y.NumericHex:
              return this.emitNumericEntity(0, 3);
            case y.NumericStart:
              return (O = this.errors) === null || O === void 0 || O.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case y.EntityStart:
              return 0;
          }
        }, _;
      }()
    );
    u.EntityDecoder = m;
    function g(_) {
      var O = "", q = new m(_, function(M) {
        return O += (0, f.fromCodePoint)(M);
      });
      return function(N, V) {
        for (var z = 0, J = 0; (J = N.indexOf("&", J)) >= 0; ) {
          O += N.slice(z, J), q.startEntity(V);
          var ee = q.write(
            N,
            // Skip the "&"
            J + 1
          );
          if (ee < 0) {
            z = J + q.end();
            break;
          }
          z = J + ee, J = ee === 0 ? z + 1 : z;
        }
        var te = O + N.slice(z);
        return O = "", te;
      };
    }
    function x(_, O, q, M) {
      var N = (O & c.BRANCH_LENGTH) >> 7, V = O & c.JUMP_TABLE;
      if (N === 0)
        return V !== 0 && M === V ? q : -1;
      if (V) {
        var z = M - V;
        return z < 0 || z >= N ? -1 : _[q + z] - 1;
      }
      for (var J = q, ee = J + N - 1; J <= ee; ) {
        var te = J + ee >>> 1, oe = _[te];
        if (oe < M)
          J = te + 1;
        else if (oe > M)
          ee = te - 1;
        else
          return _[te + N];
      }
      return -1;
    }
    u.determineBranch = x;
    var s = g(h.default), w = g(a.default);
    function S(_, O) {
      return O === void 0 && (O = n.Legacy), s(_, O);
    }
    u.decodeHTML = S;
    function A(_) {
      return s(_, n.Attribute);
    }
    u.decodeHTMLAttribute = A;
    function P(_) {
      return s(_, n.Strict);
    }
    u.decodeHTMLStrict = P;
    function R(_) {
      return w(_, n.Strict);
    }
    u.decodeXML = R;
  }(pe)), pe;
}
var Au;
function Rr() {
  return Au || (Au = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.QuoteType = void 0;
    var E = /* @__PURE__ */ rt(), v;
    (function(e) {
      e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
    })(v || (v = {}));
    var l;
    (function(e) {
      e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.SpecialStartSequence = 23] = "SpecialStartSequence", e[e.InSpecialTag = 24] = "InSpecialTag", e[e.BeforeEntity = 25] = "BeforeEntity", e[e.BeforeNumericEntity = 26] = "BeforeNumericEntity", e[e.InNamedEntity = 27] = "InNamedEntity", e[e.InNumericEntity = 28] = "InNumericEntity", e[e.InHexEntity = 29] = "InHexEntity";
    })(l || (l = {}));
    function d(e) {
      return e === v.Space || e === v.NewLine || e === v.Tab || e === v.FormFeed || e === v.CarriageReturn;
    }
    function h(e) {
      return e === v.Slash || e === v.Gt || d(e);
    }
    function a(e) {
      return e >= v.Zero && e <= v.Nine;
    }
    function f(e) {
      return e >= v.LowerA && e <= v.LowerZ || e >= v.UpperA && e <= v.UpperZ;
    }
    function p(e) {
      return e >= v.UpperA && e <= v.UpperF || e >= v.LowerA && e <= v.LowerF;
    }
    var i;
    (function(e) {
      e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
    })(i = u.QuoteType || (u.QuoteType = {}));
    var r = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    }, c = (
      /** @class */
      function() {
        function e(t, o) {
          var b = t.xmlMode, y = b === void 0 ? !1 : b, n = t.decodeEntities, m = n === void 0 ? !0 : n;
          this.cbs = o, this.state = l.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = l.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = y, this.decodeEntities = m, this.entityTrie = y ? E.xmlDecodeTree : E.htmlDecodeTree;
        }
        return e.prototype.reset = function() {
          this.state = l.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = l.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        }, e.prototype.write = function(t) {
          this.offset += this.buffer.length, this.buffer = t, this.parse();
        }, e.prototype.end = function() {
          this.running && this.finish();
        }, e.prototype.pause = function() {
          this.running = !1;
        }, e.prototype.resume = function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        }, e.prototype.getIndex = function() {
          return this.index;
        }, e.prototype.getSectionStart = function() {
          return this.sectionStart;
        }, e.prototype.stateText = function(t) {
          t === v.Lt || !this.decodeEntities && this.fastForwardTo(v.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = l.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && t === v.Amp && (this.state = l.BeforeEntity);
        }, e.prototype.stateSpecialStartSequence = function(t) {
          var o = this.sequenceIndex === this.currentSequence.length, b = o ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            h(t)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (t | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!b)
            this.isSpecial = !1;
          else if (!o) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0, this.state = l.InTagName, this.stateInTagName(t);
        }, e.prototype.stateInSpecialTag = function(t) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (t === v.Gt || d(t)) {
              var o = this.index - this.currentSequence.length;
              if (this.sectionStart < o) {
                var b = this.index;
                this.index = o, this.cbs.ontext(this.sectionStart, o), this.index = b;
              }
              this.isSpecial = !1, this.sectionStart = o + 2, this.stateInClosingTagName(t);
              return;
            }
            this.sequenceIndex = 0;
          }
          (t | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === r.TitleEnd ? this.decodeEntities && t === v.Amp && (this.state = l.BeforeEntity) : this.fastForwardTo(v.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(t === v.Lt);
        }, e.prototype.stateCDATASequence = function(t) {
          t === r.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === r.Cdata.length && (this.state = l.InCommentLike, this.currentSequence = r.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = l.InDeclaration, this.stateInDeclaration(t));
        }, e.prototype.fastForwardTo = function(t) {
          for (; ++this.index < this.buffer.length + this.offset; )
            if (this.buffer.charCodeAt(this.index - this.offset) === t)
              return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        }, e.prototype.stateInCommentLike = function(t) {
          t === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === r.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = l.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : t !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        }, e.prototype.isTagStartChar = function(t) {
          return this.xmlMode ? !h(t) : f(t);
        }, e.prototype.startSpecial = function(t, o) {
          this.isSpecial = !0, this.currentSequence = t, this.sequenceIndex = o, this.state = l.SpecialStartSequence;
        }, e.prototype.stateBeforeTagName = function(t) {
          if (t === v.ExclamationMark)
            this.state = l.BeforeDeclaration, this.sectionStart = this.index + 1;
          else if (t === v.Questionmark)
            this.state = l.InProcessingInstruction, this.sectionStart = this.index + 1;
          else if (this.isTagStartChar(t)) {
            var o = t | 32;
            this.sectionStart = this.index, !this.xmlMode && o === r.TitleEnd[2] ? this.startSpecial(r.TitleEnd, 3) : this.state = !this.xmlMode && o === r.ScriptEnd[2] ? l.BeforeSpecialS : l.InTagName;
          } else t === v.Slash ? this.state = l.BeforeClosingTagName : (this.state = l.Text, this.stateText(t));
        }, e.prototype.stateInTagName = function(t) {
          h(t) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t));
        }, e.prototype.stateBeforeClosingTagName = function(t) {
          d(t) || (t === v.Gt ? this.state = l.Text : (this.state = this.isTagStartChar(t) ? l.InClosingTagName : l.InSpecialComment, this.sectionStart = this.index));
        }, e.prototype.stateInClosingTagName = function(t) {
          (t === v.Gt || d(t)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.AfterClosingTagName, this.stateAfterClosingTagName(t));
        }, e.prototype.stateAfterClosingTagName = function(t) {
          (t === v.Gt || this.fastForwardTo(v.Gt)) && (this.state = l.Text, this.baseState = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeAttributeName = function(t) {
          t === v.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = l.InSpecialTag, this.sequenceIndex = 0) : this.state = l.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : t === v.Slash ? this.state = l.InSelfClosingTag : d(t) || (this.state = l.InAttributeName, this.sectionStart = this.index);
        }, e.prototype.stateInSelfClosingTag = function(t) {
          t === v.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = l.Text, this.baseState = l.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : d(t) || (this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t));
        }, e.prototype.stateInAttributeName = function(t) {
          (t === v.Eq || h(t)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = l.AfterAttributeName, this.stateAfterAttributeName(t));
        }, e.prototype.stateAfterAttributeName = function(t) {
          t === v.Eq ? this.state = l.BeforeAttributeValue : t === v.Slash || t === v.Gt ? (this.cbs.onattribend(i.NoValue, this.index), this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t)) : d(t) || (this.cbs.onattribend(i.NoValue, this.index), this.state = l.InAttributeName, this.sectionStart = this.index);
        }, e.prototype.stateBeforeAttributeValue = function(t) {
          t === v.DoubleQuote ? (this.state = l.InAttributeValueDq, this.sectionStart = this.index + 1) : t === v.SingleQuote ? (this.state = l.InAttributeValueSq, this.sectionStart = this.index + 1) : d(t) || (this.sectionStart = this.index, this.state = l.InAttributeValueNq, this.stateInAttributeValueNoQuotes(t));
        }, e.prototype.handleInAttributeValue = function(t, o) {
          t === o || !this.decodeEntities && this.fastForwardTo(o) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(o === v.DoubleQuote ? i.Double : i.Single, this.index), this.state = l.BeforeAttributeName) : this.decodeEntities && t === v.Amp && (this.baseState = this.state, this.state = l.BeforeEntity);
        }, e.prototype.stateInAttributeValueDoubleQuotes = function(t) {
          this.handleInAttributeValue(t, v.DoubleQuote);
        }, e.prototype.stateInAttributeValueSingleQuotes = function(t) {
          this.handleInAttributeValue(t, v.SingleQuote);
        }, e.prototype.stateInAttributeValueNoQuotes = function(t) {
          d(t) || t === v.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(i.Unquoted, this.index), this.state = l.BeforeAttributeName, this.stateBeforeAttributeName(t)) : this.decodeEntities && t === v.Amp && (this.baseState = this.state, this.state = l.BeforeEntity);
        }, e.prototype.stateBeforeDeclaration = function(t) {
          t === v.OpeningSquareBracket ? (this.state = l.CDATASequence, this.sequenceIndex = 0) : this.state = t === v.Dash ? l.BeforeComment : l.InDeclaration;
        }, e.prototype.stateInDeclaration = function(t) {
          (t === v.Gt || this.fastForwardTo(v.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateInProcessingInstruction = function(t) {
          (t === v.Gt || this.fastForwardTo(v.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeComment = function(t) {
          t === v.Dash ? (this.state = l.InCommentLike, this.currentSequence = r.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = l.InDeclaration;
        }, e.prototype.stateInSpecialComment = function(t) {
          (t === v.Gt || this.fastForwardTo(v.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = l.Text, this.sectionStart = this.index + 1);
        }, e.prototype.stateBeforeSpecialS = function(t) {
          var o = t | 32;
          o === r.ScriptEnd[3] ? this.startSpecial(r.ScriptEnd, 4) : o === r.StyleEnd[3] ? this.startSpecial(r.StyleEnd, 4) : (this.state = l.InTagName, this.stateInTagName(t));
        }, e.prototype.stateBeforeEntity = function(t) {
          this.entityExcess = 1, this.entityResult = 0, t === v.Number ? this.state = l.BeforeNumericEntity : t === v.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = l.InNamedEntity, this.stateInNamedEntity(t));
        }, e.prototype.stateInNamedEntity = function(t) {
          if (this.entityExcess += 1, this.trieIndex = (0, E.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, t), this.trieIndex < 0) {
            this.emitNamedEntity(), this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var o = this.trieCurrent & E.BinTrieFlags.VALUE_LENGTH;
          if (o) {
            var b = (o >> 14) - 1;
            if (!this.allowLegacyEntity() && t !== v.Semi)
              this.trieIndex += b;
            else {
              var y = this.index - this.entityExcess + 1;
              y > this.sectionStart && this.emitPartial(this.sectionStart, y), this.entityResult = this.trieIndex, this.trieIndex += b, this.entityExcess = 0, this.sectionStart = this.index + 1, b === 0 && this.emitNamedEntity();
            }
          }
        }, e.prototype.emitNamedEntity = function() {
          if (this.state = this.baseState, this.entityResult !== 0) {
            var t = (this.entityTrie[this.entityResult] & E.BinTrieFlags.VALUE_LENGTH) >> 14;
            switch (t) {
              case 1: {
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~E.BinTrieFlags.VALUE_LENGTH);
                break;
              }
              case 2: {
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
              }
              case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        }, e.prototype.stateBeforeNumericEntity = function(t) {
          (t | 32) === v.LowerX ? (this.entityExcess++, this.state = l.InHexEntity) : (this.state = l.InNumericEntity, this.stateInNumericEntity(t));
        }, e.prototype.emitNumericEntity = function(t) {
          var o = this.index - this.entityExcess - 1, b = o + 2 + +(this.state === l.InHexEntity);
          b !== this.index && (o > this.sectionStart && this.emitPartial(this.sectionStart, o), this.sectionStart = this.index + Number(t), this.emitCodePoint((0, E.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        }, e.prototype.stateInNumericEntity = function(t) {
          t === v.Semi ? this.emitNumericEntity(!0) : a(t) ? (this.entityResult = this.entityResult * 10 + (t - v.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, e.prototype.stateInHexEntity = function(t) {
          t === v.Semi ? this.emitNumericEntity(!0) : a(t) ? (this.entityResult = this.entityResult * 16 + (t - v.Zero), this.entityExcess++) : p(t) ? (this.entityResult = this.entityResult * 16 + ((t | 32) - v.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, e.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === l.Text || this.baseState === l.InSpecialTag);
        }, e.prototype.cleanup = function() {
          this.running && this.sectionStart !== this.index && (this.state === l.Text || this.state === l.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === l.InAttributeValueDq || this.state === l.InAttributeValueSq || this.state === l.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        }, e.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        }, e.prototype.parse = function() {
          for (; this.shouldContinue(); ) {
            var t = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case l.Text: {
                this.stateText(t);
                break;
              }
              case l.SpecialStartSequence: {
                this.stateSpecialStartSequence(t);
                break;
              }
              case l.InSpecialTag: {
                this.stateInSpecialTag(t);
                break;
              }
              case l.CDATASequence: {
                this.stateCDATASequence(t);
                break;
              }
              case l.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(t);
                break;
              }
              case l.InAttributeName: {
                this.stateInAttributeName(t);
                break;
              }
              case l.InCommentLike: {
                this.stateInCommentLike(t);
                break;
              }
              case l.InSpecialComment: {
                this.stateInSpecialComment(t);
                break;
              }
              case l.BeforeAttributeName: {
                this.stateBeforeAttributeName(t);
                break;
              }
              case l.InTagName: {
                this.stateInTagName(t);
                break;
              }
              case l.InClosingTagName: {
                this.stateInClosingTagName(t);
                break;
              }
              case l.BeforeTagName: {
                this.stateBeforeTagName(t);
                break;
              }
              case l.AfterAttributeName: {
                this.stateAfterAttributeName(t);
                break;
              }
              case l.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(t);
                break;
              }
              case l.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(t);
                break;
              }
              case l.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(t);
                break;
              }
              case l.AfterClosingTagName: {
                this.stateAfterClosingTagName(t);
                break;
              }
              case l.BeforeSpecialS: {
                this.stateBeforeSpecialS(t);
                break;
              }
              case l.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(t);
                break;
              }
              case l.InSelfClosingTag: {
                this.stateInSelfClosingTag(t);
                break;
              }
              case l.InDeclaration: {
                this.stateInDeclaration(t);
                break;
              }
              case l.BeforeDeclaration: {
                this.stateBeforeDeclaration(t);
                break;
              }
              case l.BeforeComment: {
                this.stateBeforeComment(t);
                break;
              }
              case l.InProcessingInstruction: {
                this.stateInProcessingInstruction(t);
                break;
              }
              case l.InNamedEntity: {
                this.stateInNamedEntity(t);
                break;
              }
              case l.BeforeEntity: {
                this.stateBeforeEntity(t);
                break;
              }
              case l.InHexEntity: {
                this.stateInHexEntity(t);
                break;
              }
              case l.InNumericEntity: {
                this.stateInNumericEntity(t);
                break;
              }
              default:
                this.stateBeforeNumericEntity(t);
            }
            this.index++;
          }
          this.cleanup();
        }, e.prototype.finish = function() {
          this.state === l.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        }, e.prototype.handleTrailingData = function() {
          var t = this.buffer.length + this.offset;
          this.state === l.InCommentLike ? this.currentSequence === r.CdataEnd ? this.cbs.oncdata(this.sectionStart, t, 0) : this.cbs.oncomment(this.sectionStart, t, 0) : this.state === l.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === l.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === l.InTagName || this.state === l.BeforeAttributeName || this.state === l.BeforeAttributeValue || this.state === l.AfterAttributeName || this.state === l.InAttributeName || this.state === l.InAttributeValueSq || this.state === l.InAttributeValueDq || this.state === l.InAttributeValueNq || this.state === l.InClosingTagName || this.cbs.ontext(this.sectionStart, t);
        }, e.prototype.emitPartial = function(t, o) {
          this.baseState !== l.Text && this.baseState !== l.InSpecialTag ? this.cbs.onattribdata(t, o) : this.cbs.ontext(t, o);
        }, e.prototype.emitCodePoint = function(t) {
          this.baseState !== l.Text && this.baseState !== l.InSpecialTag ? this.cbs.onattribentity(t) : this.cbs.ontextentity(t);
        }, e;
      }()
    );
    u.default = c;
  }(yt)), yt;
}
var _u;
function Ou() {
  if (_u) return he;
  _u = 1;
  var u = he && he.__createBinding || (Object.create ? function(y, n, m, g) {
    g === void 0 && (g = m);
    var x = Object.getOwnPropertyDescriptor(n, m);
    (!x || ("get" in x ? !n.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
      return n[m];
    } }), Object.defineProperty(y, g, x);
  } : function(y, n, m, g) {
    g === void 0 && (g = m), y[g] = n[m];
  }), E = he && he.__setModuleDefault || (Object.create ? function(y, n) {
    Object.defineProperty(y, "default", { enumerable: !0, value: n });
  } : function(y, n) {
    y.default = n;
  }), v = he && he.__importStar || function(y) {
    if (y && y.__esModule) return y;
    var n = {};
    if (y != null) for (var m in y) m !== "default" && Object.prototype.hasOwnProperty.call(y, m) && u(n, y, m);
    return E(n, y), n;
  };
  Object.defineProperty(he, "__esModule", { value: !0 }), he.Parser = void 0;
  var l = v(/* @__PURE__ */ Rr()), d = /* @__PURE__ */ rt(), h = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), a = /* @__PURE__ */ new Set(["p"]), f = /* @__PURE__ */ new Set(["thead", "tbody"]), p = /* @__PURE__ */ new Set(["dd", "dt"]), i = /* @__PURE__ */ new Set(["rt", "rp"]), r = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", a],
    ["h1", a],
    ["h2", a],
    ["h3", a],
    ["h4", a],
    ["h5", a],
    ["h6", a],
    ["select", h],
    ["input", h],
    ["output", h],
    ["button", h],
    ["datalist", h],
    ["textarea", h],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", p],
    ["dt", p],
    ["address", a],
    ["article", a],
    ["aside", a],
    ["blockquote", a],
    ["details", a],
    ["div", a],
    ["dl", a],
    ["fieldset", a],
    ["figcaption", a],
    ["figure", a],
    ["footer", a],
    ["form", a],
    ["header", a],
    ["hr", a],
    ["main", a],
    ["nav", a],
    ["ol", a],
    ["pre", a],
    ["section", a],
    ["table", a],
    ["ul", a],
    ["rt", i],
    ["rp", i],
    ["tbody", f],
    ["tfoot", f]
  ]), c = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), e = /* @__PURE__ */ new Set(["math", "svg"]), t = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), o = /\s|\//, b = (
    /** @class */
    function() {
      function y(n, m) {
        m === void 0 && (m = {});
        var g, x, s, w, S;
        this.options = m, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = n ?? {}, this.lowerCaseTagNames = (g = m.lowerCaseTags) !== null && g !== void 0 ? g : !m.xmlMode, this.lowerCaseAttributeNames = (x = m.lowerCaseAttributeNames) !== null && x !== void 0 ? x : !m.xmlMode, this.tokenizer = new ((s = m.Tokenizer) !== null && s !== void 0 ? s : l.default)(this.options, this), (S = (w = this.cbs).onparserinit) === null || S === void 0 || S.call(w, this);
      }
      return y.prototype.ontext = function(n, m) {
        var g, x, s = this.getSlice(n, m);
        this.endIndex = m - 1, (x = (g = this.cbs).ontext) === null || x === void 0 || x.call(g, s), this.startIndex = m;
      }, y.prototype.ontextentity = function(n) {
        var m, g, x = this.tokenizer.getSectionStart();
        this.endIndex = x - 1, (g = (m = this.cbs).ontext) === null || g === void 0 || g.call(m, (0, d.fromCodePoint)(n)), this.startIndex = x;
      }, y.prototype.isVoidElement = function(n) {
        return !this.options.xmlMode && c.has(n);
      }, y.prototype.onopentagname = function(n, m) {
        this.endIndex = m;
        var g = this.getSlice(n, m);
        this.lowerCaseTagNames && (g = g.toLowerCase()), this.emitOpenTag(g);
      }, y.prototype.emitOpenTag = function(n) {
        var m, g, x, s;
        this.openTagStart = this.startIndex, this.tagname = n;
        var w = !this.options.xmlMode && r.get(n);
        if (w)
          for (; this.stack.length > 0 && w.has(this.stack[this.stack.length - 1]); ) {
            var S = this.stack.pop();
            (g = (m = this.cbs).onclosetag) === null || g === void 0 || g.call(m, S, !0);
          }
        this.isVoidElement(n) || (this.stack.push(n), e.has(n) ? this.foreignContext.push(!0) : t.has(n) && this.foreignContext.push(!1)), (s = (x = this.cbs).onopentagname) === null || s === void 0 || s.call(x, n), this.cbs.onopentag && (this.attribs = {});
      }, y.prototype.endOpenTag = function(n) {
        var m, g;
        this.startIndex = this.openTagStart, this.attribs && ((g = (m = this.cbs).onopentag) === null || g === void 0 || g.call(m, this.tagname, this.attribs, n), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
      }, y.prototype.onopentagend = function(n) {
        this.endIndex = n, this.endOpenTag(!1), this.startIndex = n + 1;
      }, y.prototype.onclosetag = function(n, m) {
        var g, x, s, w, S, A;
        this.endIndex = m;
        var P = this.getSlice(n, m);
        if (this.lowerCaseTagNames && (P = P.toLowerCase()), (e.has(P) || t.has(P)) && this.foreignContext.pop(), this.isVoidElement(P))
          !this.options.xmlMode && P === "br" && ((x = (g = this.cbs).onopentagname) === null || x === void 0 || x.call(g, "br"), (w = (s = this.cbs).onopentag) === null || w === void 0 || w.call(s, "br", {}, !0), (A = (S = this.cbs).onclosetag) === null || A === void 0 || A.call(S, "br", !1));
        else {
          var R = this.stack.lastIndexOf(P);
          if (R !== -1)
            if (this.cbs.onclosetag)
              for (var _ = this.stack.length - R; _--; )
                this.cbs.onclosetag(this.stack.pop(), _ !== 0);
            else
              this.stack.length = R;
          else !this.options.xmlMode && P === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
        }
        this.startIndex = m + 1;
      }, y.prototype.onselfclosingtag = function(n) {
        this.endIndex = n, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = n + 1) : this.onopentagend(n);
      }, y.prototype.closeCurrentTag = function(n) {
        var m, g, x = this.tagname;
        this.endOpenTag(n), this.stack[this.stack.length - 1] === x && ((g = (m = this.cbs).onclosetag) === null || g === void 0 || g.call(m, x, !n), this.stack.pop());
      }, y.prototype.onattribname = function(n, m) {
        this.startIndex = n;
        var g = this.getSlice(n, m);
        this.attribname = this.lowerCaseAttributeNames ? g.toLowerCase() : g;
      }, y.prototype.onattribdata = function(n, m) {
        this.attribvalue += this.getSlice(n, m);
      }, y.prototype.onattribentity = function(n) {
        this.attribvalue += (0, d.fromCodePoint)(n);
      }, y.prototype.onattribend = function(n, m) {
        var g, x;
        this.endIndex = m, (x = (g = this.cbs).onattribute) === null || x === void 0 || x.call(g, this.attribname, this.attribvalue, n === l.QuoteType.Double ? '"' : n === l.QuoteType.Single ? "'" : n === l.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
      }, y.prototype.getInstructionName = function(n) {
        var m = n.search(o), g = m < 0 ? n : n.substr(0, m);
        return this.lowerCaseTagNames && (g = g.toLowerCase()), g;
      }, y.prototype.ondeclaration = function(n, m) {
        this.endIndex = m;
        var g = this.getSlice(n, m);
        if (this.cbs.onprocessinginstruction) {
          var x = this.getInstructionName(g);
          this.cbs.onprocessinginstruction("!".concat(x), "!".concat(g));
        }
        this.startIndex = m + 1;
      }, y.prototype.onprocessinginstruction = function(n, m) {
        this.endIndex = m;
        var g = this.getSlice(n, m);
        if (this.cbs.onprocessinginstruction) {
          var x = this.getInstructionName(g);
          this.cbs.onprocessinginstruction("?".concat(x), "?".concat(g));
        }
        this.startIndex = m + 1;
      }, y.prototype.oncomment = function(n, m, g) {
        var x, s, w, S;
        this.endIndex = m, (s = (x = this.cbs).oncomment) === null || s === void 0 || s.call(x, this.getSlice(n, m - g)), (S = (w = this.cbs).oncommentend) === null || S === void 0 || S.call(w), this.startIndex = m + 1;
      }, y.prototype.oncdata = function(n, m, g) {
        var x, s, w, S, A, P, R, _, O, q;
        this.endIndex = m;
        var M = this.getSlice(n, m - g);
        this.options.xmlMode || this.options.recognizeCDATA ? ((s = (x = this.cbs).oncdatastart) === null || s === void 0 || s.call(x), (S = (w = this.cbs).ontext) === null || S === void 0 || S.call(w, M), (P = (A = this.cbs).oncdataend) === null || P === void 0 || P.call(A)) : ((_ = (R = this.cbs).oncomment) === null || _ === void 0 || _.call(R, "[CDATA[".concat(M, "]]")), (q = (O = this.cbs).oncommentend) === null || q === void 0 || q.call(O)), this.startIndex = m + 1;
      }, y.prototype.onend = function() {
        var n, m;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var g = this.stack.length; g > 0; this.cbs.onclosetag(this.stack[--g], !0))
            ;
        }
        (m = (n = this.cbs).onend) === null || m === void 0 || m.call(n);
      }, y.prototype.reset = function() {
        var n, m, g, x;
        (m = (n = this.cbs).onreset) === null || m === void 0 || m.call(n), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (x = (g = this.cbs).onparserinit) === null || x === void 0 || x.call(g, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
      }, y.prototype.parseComplete = function(n) {
        this.reset(), this.end(n);
      }, y.prototype.getSlice = function(n, m) {
        for (; n - this.bufferOffset >= this.buffers[0].length; )
          this.shiftBuffer();
        for (var g = this.buffers[0].slice(n - this.bufferOffset, m - this.bufferOffset); m - this.bufferOffset > this.buffers[0].length; )
          this.shiftBuffer(), g += this.buffers[0].slice(0, m - this.bufferOffset);
        return g;
      }, y.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
      }, y.prototype.write = function(n) {
        var m, g;
        if (this.ended) {
          (g = (m = this.cbs).onerror) === null || g === void 0 || g.call(m, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(n), this.tokenizer.running && (this.tokenizer.write(n), this.writeIndex++);
      }, y.prototype.end = function(n) {
        var m, g;
        if (this.ended) {
          (g = (m = this.cbs).onerror) === null || g === void 0 || g.call(m, new Error(".end() after done!"));
          return;
        }
        n && this.write(n), this.ended = !0, this.tokenizer.end();
      }, y.prototype.pause = function() {
        this.tokenizer.pause();
      }, y.prototype.resume = function() {
        for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        this.ended && this.tokenizer.end();
      }, y.prototype.parseChunk = function(n) {
        this.write(n);
      }, y.prototype.done = function(n) {
        this.end(n);
      }, y;
    }()
  );
  return he.Parser = b, he;
}
var Le = {}, xt = {}, Nu;
function ze() {
  return Nu || (Nu = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.Doctype = u.CDATA = u.Tag = u.Style = u.Script = u.Comment = u.Directive = u.Text = u.Root = u.isTag = u.ElementType = void 0;
    var E;
    (function(l) {
      l.Root = "root", l.Text = "text", l.Directive = "directive", l.Comment = "comment", l.Script = "script", l.Style = "style", l.Tag = "tag", l.CDATA = "cdata", l.Doctype = "doctype";
    })(E = u.ElementType || (u.ElementType = {}));
    function v(l) {
      return l.type === E.Tag || l.type === E.Script || l.type === E.Style;
    }
    u.isTag = v, u.Root = E.Root, u.Text = E.Text, u.Directive = E.Directive, u.Comment = E.Comment, u.Script = E.Script, u.Style = E.Style, u.Tag = E.Tag, u.CDATA = E.CDATA, u.Doctype = E.Doctype;
  }(xt)), xt;
}
var F = {}, Cu;
function Ru() {
  if (Cu) return F;
  Cu = 1;
  var u = F && F.__extends || /* @__PURE__ */ function() {
    var s = function(w, S) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, P) {
        A.__proto__ = P;
      } || function(A, P) {
        for (var R in P) Object.prototype.hasOwnProperty.call(P, R) && (A[R] = P[R]);
      }, s(w, S);
    };
    return function(w, S) {
      if (typeof S != "function" && S !== null)
        throw new TypeError("Class extends value " + String(S) + " is not a constructor or null");
      s(w, S);
      function A() {
        this.constructor = w;
      }
      w.prototype = S === null ? Object.create(S) : (A.prototype = S.prototype, new A());
    };
  }(), E = F && F.__assign || function() {
    return E = Object.assign || function(s) {
      for (var w, S = 1, A = arguments.length; S < A; S++) {
        w = arguments[S];
        for (var P in w) Object.prototype.hasOwnProperty.call(w, P) && (s[P] = w[P]);
      }
      return s;
    }, E.apply(this, arguments);
  };
  Object.defineProperty(F, "__esModule", { value: !0 }), F.cloneNode = F.hasChildren = F.isDocument = F.isDirective = F.isComment = F.isText = F.isCDATA = F.isTag = F.Element = F.Document = F.CDATA = F.NodeWithChildren = F.ProcessingInstruction = F.Comment = F.Text = F.DataNode = F.Node = void 0;
  var v = /* @__PURE__ */ ze(), l = (
    /** @class */
    function() {
      function s() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(s.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(w) {
          this.parent = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(w) {
          this.prev = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(s.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(w) {
          this.next = w;
        },
        enumerable: !1,
        configurable: !0
      }), s.prototype.cloneNode = function(w) {
        return w === void 0 && (w = !1), g(this, w);
      }, s;
    }()
  );
  F.Node = l;
  var d = (
    /** @class */
    function(s) {
      u(w, s);
      function w(S) {
        var A = s.call(this) || this;
        return A.data = S, A;
      }
      return Object.defineProperty(w.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(S) {
          this.data = S;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(l)
  );
  F.DataNode = d;
  var h = (
    /** @class */
    function(s) {
      u(w, s);
      function w() {
        var S = s !== null && s.apply(this, arguments) || this;
        return S.type = v.ElementType.Text, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(d)
  );
  F.Text = h;
  var a = (
    /** @class */
    function(s) {
      u(w, s);
      function w() {
        var S = s !== null && s.apply(this, arguments) || this;
        return S.type = v.ElementType.Comment, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(d)
  );
  F.Comment = a;
  var f = (
    /** @class */
    function(s) {
      u(w, s);
      function w(S, A) {
        var P = s.call(this, A) || this;
        return P.name = S, P.type = v.ElementType.Directive, P;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(d)
  );
  F.ProcessingInstruction = f;
  var p = (
    /** @class */
    function(s) {
      u(w, s);
      function w(S) {
        var A = s.call(this) || this;
        return A.children = S, A;
      }
      return Object.defineProperty(w.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var S;
          return (S = this.children[0]) !== null && S !== void 0 ? S : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(S) {
          this.children = S;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(l)
  );
  F.NodeWithChildren = p;
  var i = (
    /** @class */
    function(s) {
      u(w, s);
      function w() {
        var S = s !== null && s.apply(this, arguments) || this;
        return S.type = v.ElementType.CDATA, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(p)
  );
  F.CDATA = i;
  var r = (
    /** @class */
    function(s) {
      u(w, s);
      function w() {
        var S = s !== null && s.apply(this, arguments) || this;
        return S.type = v.ElementType.Root, S;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(p)
  );
  F.Document = r;
  var c = (
    /** @class */
    function(s) {
      u(w, s);
      function w(S, A, P, R) {
        P === void 0 && (P = []), R === void 0 && (R = S === "script" ? v.ElementType.Script : S === "style" ? v.ElementType.Style : v.ElementType.Tag);
        var _ = s.call(this, P) || this;
        return _.name = S, _.attribs = A, _.type = R, _;
      }
      return Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(S) {
          this.name = S;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(w.prototype, "attributes", {
        get: function() {
          var S = this;
          return Object.keys(this.attribs).map(function(A) {
            var P, R;
            return {
              name: A,
              value: S.attribs[A],
              namespace: (P = S["x-attribsNamespace"]) === null || P === void 0 ? void 0 : P[A],
              prefix: (R = S["x-attribsPrefix"]) === null || R === void 0 ? void 0 : R[A]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), w;
    }(p)
  );
  F.Element = c;
  function e(s) {
    return (0, v.isTag)(s);
  }
  F.isTag = e;
  function t(s) {
    return s.type === v.ElementType.CDATA;
  }
  F.isCDATA = t;
  function o(s) {
    return s.type === v.ElementType.Text;
  }
  F.isText = o;
  function b(s) {
    return s.type === v.ElementType.Comment;
  }
  F.isComment = b;
  function y(s) {
    return s.type === v.ElementType.Directive;
  }
  F.isDirective = y;
  function n(s) {
    return s.type === v.ElementType.Root;
  }
  F.isDocument = n;
  function m(s) {
    return Object.prototype.hasOwnProperty.call(s, "children");
  }
  F.hasChildren = m;
  function g(s, w) {
    w === void 0 && (w = !1);
    var S;
    if (o(s))
      S = new h(s.data);
    else if (b(s))
      S = new a(s.data);
    else if (e(s)) {
      var A = w ? x(s.children) : [], P = new c(s.name, E({}, s.attribs), A);
      A.forEach(function(q) {
        return q.parent = P;
      }), s.namespace != null && (P.namespace = s.namespace), s["x-attribsNamespace"] && (P["x-attribsNamespace"] = E({}, s["x-attribsNamespace"])), s["x-attribsPrefix"] && (P["x-attribsPrefix"] = E({}, s["x-attribsPrefix"])), S = P;
    } else if (t(s)) {
      var A = w ? x(s.children) : [], R = new i(A);
      A.forEach(function(M) {
        return M.parent = R;
      }), S = R;
    } else if (n(s)) {
      var A = w ? x(s.children) : [], _ = new r(A);
      A.forEach(function(M) {
        return M.parent = _;
      }), s["x-mode"] && (_["x-mode"] = s["x-mode"]), S = _;
    } else if (y(s)) {
      var O = new f(s.name, s.data);
      s["x-name"] != null && (O["x-name"] = s["x-name"], O["x-publicId"] = s["x-publicId"], O["x-systemId"] = s["x-systemId"]), S = O;
    } else
      throw new Error("Not implemented yet: ".concat(s.type));
    return S.startIndex = s.startIndex, S.endIndex = s.endIndex, s.sourceCodeLocation != null && (S.sourceCodeLocation = s.sourceCodeLocation), S;
  }
  F.cloneNode = g;
  function x(s) {
    for (var w = s.map(function(A) {
      return g(A, !0);
    }), S = 1; S < w.length; S++)
      w[S].prev = w[S - 1], w[S - 1].next = w[S];
    return w;
  }
  return F;
}
var Pu;
function Ie() {
  return Pu || (Pu = 1, function(u) {
    var E = Le && Le.__createBinding || (Object.create ? function(f, p, i, r) {
      r === void 0 && (r = i);
      var c = Object.getOwnPropertyDescriptor(p, i);
      (!c || ("get" in c ? !p.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
        return p[i];
      } }), Object.defineProperty(f, r, c);
    } : function(f, p, i, r) {
      r === void 0 && (r = i), f[r] = p[i];
    }), v = Le && Le.__exportStar || function(f, p) {
      for (var i in f) i !== "default" && !Object.prototype.hasOwnProperty.call(p, i) && E(p, f, i);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomHandler = void 0;
    var l = /* @__PURE__ */ ze(), d = /* @__PURE__ */ Ru();
    v(/* @__PURE__ */ Ru(), u);
    var h = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, a = (
      /** @class */
      function() {
        function f(p, i, r) {
          this.dom = [], this.root = new d.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof i == "function" && (r = i, i = h), typeof p == "object" && (i = p, p = void 0), this.callback = p ?? null, this.options = i ?? h, this.elementCB = r ?? null;
        }
        return f.prototype.onparserinit = function(p) {
          this.parser = p;
        }, f.prototype.onreset = function() {
          this.dom = [], this.root = new d.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, f.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, f.prototype.onerror = function(p) {
          this.handleCallback(p);
        }, f.prototype.onclosetag = function() {
          this.lastNode = null;
          var p = this.tagStack.pop();
          this.options.withEndIndices && (p.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(p);
        }, f.prototype.onopentag = function(p, i) {
          var r = this.options.xmlMode ? l.ElementType.Tag : void 0, c = new d.Element(p, i, void 0, r);
          this.addNode(c), this.tagStack.push(c);
        }, f.prototype.ontext = function(p) {
          var i = this.lastNode;
          if (i && i.type === l.ElementType.Text)
            i.data += p, this.options.withEndIndices && (i.endIndex = this.parser.endIndex);
          else {
            var r = new d.Text(p);
            this.addNode(r), this.lastNode = r;
          }
        }, f.prototype.oncomment = function(p) {
          if (this.lastNode && this.lastNode.type === l.ElementType.Comment) {
            this.lastNode.data += p;
            return;
          }
          var i = new d.Comment(p);
          this.addNode(i), this.lastNode = i;
        }, f.prototype.oncommentend = function() {
          this.lastNode = null;
        }, f.prototype.oncdatastart = function() {
          var p = new d.Text(""), i = new d.CDATA([p]);
          this.addNode(i), p.parent = i, this.lastNode = p;
        }, f.prototype.oncdataend = function() {
          this.lastNode = null;
        }, f.prototype.onprocessinginstruction = function(p, i) {
          var r = new d.ProcessingInstruction(p, i);
          this.addNode(r);
        }, f.prototype.handleCallback = function(p) {
          if (typeof this.callback == "function")
            this.callback(p, this.dom);
          else if (p)
            throw p;
        }, f.prototype.addNode = function(p) {
          var i = this.tagStack[this.tagStack.length - 1], r = i.children[i.children.length - 1];
          this.options.withStartIndices && (p.startIndex = this.parser.startIndex), this.options.withEndIndices && (p.endIndex = this.parser.endIndex), i.children.push(p), r && (p.prev = r, r.next = p), p.parent = i, this.lastNode = null;
        }, f;
      }()
    );
    u.DomHandler = a, u.default = a;
  }(Le)), Le;
}
var Me = {}, ye = {}, se = {}, wt = {}, Te = {}, Qe = {}, Iu;
function ci() {
  if (Iu) return Qe;
  Iu = 1, Object.defineProperty(Qe, "__esModule", { value: !0 });
  function u(E) {
    for (var v = 1; v < E.length; v++)
      E[v][0] += E[v - 1][0] + 1;
    return E;
  }
  return Qe.default = new Map(/* @__PURE__ */ u([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ u([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ u([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ u([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), Qe;
}
var Et = {}, Du;
function eu() {
  return Du || (Du = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.getCodePoint = u.xmlReplacer = void 0, u.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var E = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    u.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(d, h) {
      return d.codePointAt(h);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(d, h) {
        return (d.charCodeAt(h) & 64512) === 55296 ? (d.charCodeAt(h) - 55296) * 1024 + d.charCodeAt(h + 1) - 56320 + 65536 : d.charCodeAt(h);
      }
    );
    function v(d) {
      for (var h = "", a = 0, f; (f = u.xmlReplacer.exec(d)) !== null; ) {
        var p = f.index, i = d.charCodeAt(p), r = E.get(i);
        r !== void 0 ? (h += d.substring(a, p) + r, a = p + 1) : (h += "".concat(d.substring(a, p), "&#x").concat((0, u.getCodePoint)(d, p).toString(16), ";"), a = u.xmlReplacer.lastIndex += +((i & 64512) === 55296));
      }
      return h + d.substr(a);
    }
    u.encodeXML = v, u.escape = v;
    function l(d, h) {
      return function(f) {
        for (var p, i = 0, r = ""; p = d.exec(f); )
          i !== p.index && (r += f.substring(i, p.index)), r += h.get(p[0].charCodeAt(0)), i = p.index + 1;
        return r + f.substring(i);
      };
    }
    u.escapeUTF8 = l(/[&<>'"]/g, E), u.escapeAttribute = l(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), u.escapeText = l(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  }(Et)), Et;
}
var qu;
function Lu() {
  if (qu) return Te;
  qu = 1;
  var u = Te && Te.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(Te, "__esModule", { value: !0 }), Te.encodeNonAsciiHTML = Te.encodeHTML = void 0;
  var E = u(/* @__PURE__ */ ci()), v = /* @__PURE__ */ eu(), l = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function d(f) {
    return a(l, f);
  }
  Te.encodeHTML = d;
  function h(f) {
    return a(v.xmlReplacer, f);
  }
  Te.encodeNonAsciiHTML = h;
  function a(f, p) {
    for (var i = "", r = 0, c; (c = f.exec(p)) !== null; ) {
      var e = c.index;
      i += p.substring(r, e);
      var t = p.charCodeAt(e), o = E.default.get(t);
      if (typeof o == "object") {
        if (e + 1 < p.length) {
          var b = p.charCodeAt(e + 1), y = typeof o.n == "number" ? o.n === b ? o.o : void 0 : o.n.get(b);
          if (y !== void 0) {
            i += y, r = f.lastIndex += 1;
            continue;
          }
        }
        o = o.v;
      }
      if (o !== void 0)
        i += o, r = e + 1;
      else {
        var n = (0, v.getCodePoint)(p, e);
        i += "&#x".concat(n.toString(16), ";"), r = f.lastIndex += +(n !== t);
      }
    }
    return i + p.substr(r);
  }
  return Te;
}
var Mu;
function li() {
  return Mu || (Mu = 1, function(u) {
    Object.defineProperty(u, "__esModule", { value: !0 }), u.decodeXMLStrict = u.decodeHTML5Strict = u.decodeHTML4Strict = u.decodeHTML5 = u.decodeHTML4 = u.decodeHTMLAttribute = u.decodeHTMLStrict = u.decodeHTML = u.decodeXML = u.DecodingMode = u.EntityDecoder = u.encodeHTML5 = u.encodeHTML4 = u.encodeNonAsciiHTML = u.encodeHTML = u.escapeText = u.escapeAttribute = u.escapeUTF8 = u.escape = u.encodeXML = u.encode = u.decodeStrict = u.decode = u.EncodingMode = u.EntityLevel = void 0;
    var E = /* @__PURE__ */ rt(), v = /* @__PURE__ */ Lu(), l = /* @__PURE__ */ eu(), d;
    (function(e) {
      e[e.XML = 0] = "XML", e[e.HTML = 1] = "HTML";
    })(d = u.EntityLevel || (u.EntityLevel = {}));
    var h;
    (function(e) {
      e[e.UTF8 = 0] = "UTF8", e[e.ASCII = 1] = "ASCII", e[e.Extensive = 2] = "Extensive", e[e.Attribute = 3] = "Attribute", e[e.Text = 4] = "Text";
    })(h = u.EncodingMode || (u.EncodingMode = {}));
    function a(e, t) {
      t === void 0 && (t = d.XML);
      var o = typeof t == "number" ? t : t.level;
      if (o === d.HTML) {
        var b = typeof t == "object" ? t.mode : void 0;
        return (0, E.decodeHTML)(e, b);
      }
      return (0, E.decodeXML)(e);
    }
    u.decode = a;
    function f(e, t) {
      var o;
      t === void 0 && (t = d.XML);
      var b = typeof t == "number" ? { level: t } : t;
      return (o = b.mode) !== null && o !== void 0 || (b.mode = E.DecodingMode.Strict), a(e, b);
    }
    u.decodeStrict = f;
    function p(e, t) {
      t === void 0 && (t = d.XML);
      var o = typeof t == "number" ? { level: t } : t;
      return o.mode === h.UTF8 ? (0, l.escapeUTF8)(e) : o.mode === h.Attribute ? (0, l.escapeAttribute)(e) : o.mode === h.Text ? (0, l.escapeText)(e) : o.level === d.HTML ? o.mode === h.ASCII ? (0, v.encodeNonAsciiHTML)(e) : (0, v.encodeHTML)(e) : (0, l.encodeXML)(e);
    }
    u.encode = p;
    var i = /* @__PURE__ */ eu();
    Object.defineProperty(u, "encodeXML", { enumerable: !0, get: function() {
      return i.encodeXML;
    } }), Object.defineProperty(u, "escape", { enumerable: !0, get: function() {
      return i.escape;
    } }), Object.defineProperty(u, "escapeUTF8", { enumerable: !0, get: function() {
      return i.escapeUTF8;
    } }), Object.defineProperty(u, "escapeAttribute", { enumerable: !0, get: function() {
      return i.escapeAttribute;
    } }), Object.defineProperty(u, "escapeText", { enumerable: !0, get: function() {
      return i.escapeText;
    } });
    var r = /* @__PURE__ */ Lu();
    Object.defineProperty(u, "encodeHTML", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } }), Object.defineProperty(u, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return r.encodeNonAsciiHTML;
    } }), Object.defineProperty(u, "encodeHTML4", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } }), Object.defineProperty(u, "encodeHTML5", { enumerable: !0, get: function() {
      return r.encodeHTML;
    } });
    var c = /* @__PURE__ */ rt();
    Object.defineProperty(u, "EntityDecoder", { enumerable: !0, get: function() {
      return c.EntityDecoder;
    } }), Object.defineProperty(u, "DecodingMode", { enumerable: !0, get: function() {
      return c.DecodingMode;
    } }), Object.defineProperty(u, "decodeXML", { enumerable: !0, get: function() {
      return c.decodeXML;
    } }), Object.defineProperty(u, "decodeHTML", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return c.decodeHTMLAttribute;
    } }), Object.defineProperty(u, "decodeHTML4", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML5", { enumerable: !0, get: function() {
      return c.decodeHTML;
    } }), Object.defineProperty(u, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return c.decodeHTMLStrict;
    } }), Object.defineProperty(u, "decodeXMLStrict", { enumerable: !0, get: function() {
      return c.decodeXML;
    } });
  }(wt)), wt;
}
var ke = {}, ku;
function fi() {
  return ku || (ku = 1, Object.defineProperty(ke, "__esModule", { value: !0 }), ke.attributeNames = ke.elementNames = void 0, ke.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  })), ke.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(u) {
    return [u.toLowerCase(), u];
  }))), ke;
}
var ju;
function di() {
  if (ju) return se;
  ju = 1;
  var u = se && se.__assign || function() {
    return u = Object.assign || function(x) {
      for (var s, w = 1, S = arguments.length; w < S; w++) {
        s = arguments[w];
        for (var A in s) Object.prototype.hasOwnProperty.call(s, A) && (x[A] = s[A]);
      }
      return x;
    }, u.apply(this, arguments);
  }, E = se && se.__createBinding || (Object.create ? function(x, s, w, S) {
    S === void 0 && (S = w);
    var A = Object.getOwnPropertyDescriptor(s, w);
    (!A || ("get" in A ? !s.__esModule : A.writable || A.configurable)) && (A = { enumerable: !0, get: function() {
      return s[w];
    } }), Object.defineProperty(x, S, A);
  } : function(x, s, w, S) {
    S === void 0 && (S = w), x[S] = s[w];
  }), v = se && se.__setModuleDefault || (Object.create ? function(x, s) {
    Object.defineProperty(x, "default", { enumerable: !0, value: s });
  } : function(x, s) {
    x.default = s;
  }), l = se && se.__importStar || function(x) {
    if (x && x.__esModule) return x;
    var s = {};
    if (x != null) for (var w in x) w !== "default" && Object.prototype.hasOwnProperty.call(x, w) && E(s, x, w);
    return v(s, x), s;
  };
  Object.defineProperty(se, "__esModule", { value: !0 }), se.render = void 0;
  var d = l(/* @__PURE__ */ ze()), h = /* @__PURE__ */ li(), a = /* @__PURE__ */ fi(), f = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function p(x) {
    return x.replace(/"/g, "&quot;");
  }
  function i(x, s) {
    var w;
    if (x) {
      var S = ((w = s.encodeEntities) !== null && w !== void 0 ? w : s.decodeEntities) === !1 ? p : s.xmlMode || s.encodeEntities !== "utf8" ? h.encodeXML : h.escapeAttribute;
      return Object.keys(x).map(function(A) {
        var P, R, _ = (P = x[A]) !== null && P !== void 0 ? P : "";
        return s.xmlMode === "foreign" && (A = (R = a.attributeNames.get(A)) !== null && R !== void 0 ? R : A), !s.emptyAttrs && !s.xmlMode && _ === "" ? A : "".concat(A, '="').concat(S(_), '"');
      }).join(" ");
    }
  }
  var r = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function c(x, s) {
    s === void 0 && (s = {});
    for (var w = ("length" in x) ? x : [x], S = "", A = 0; A < w.length; A++)
      S += e(w[A], s);
    return S;
  }
  se.render = c, se.default = c;
  function e(x, s) {
    switch (x.type) {
      case d.Root:
        return c(x.children, s);
      // @ts-expect-error We don't use `Doctype` yet
      case d.Doctype:
      case d.Directive:
        return y(x);
      case d.Comment:
        return g(x);
      case d.CDATA:
        return m(x);
      case d.Script:
      case d.Style:
      case d.Tag:
        return b(x, s);
      case d.Text:
        return n(x, s);
    }
  }
  var t = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), o = /* @__PURE__ */ new Set(["svg", "math"]);
  function b(x, s) {
    var w;
    s.xmlMode === "foreign" && (x.name = (w = a.elementNames.get(x.name)) !== null && w !== void 0 ? w : x.name, x.parent && t.has(x.parent.name) && (s = u(u({}, s), { xmlMode: !1 }))), !s.xmlMode && o.has(x.name) && (s = u(u({}, s), { xmlMode: "foreign" }));
    var S = "<".concat(x.name), A = i(x.attribs, s);
    return A && (S += " ".concat(A)), x.children.length === 0 && (s.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      s.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      s.selfClosingTags && r.has(x.name)
    )) ? (s.xmlMode || (S += " "), S += "/>") : (S += ">", x.children.length > 0 && (S += c(x.children, s)), (s.xmlMode || !r.has(x.name)) && (S += "</".concat(x.name, ">"))), S;
  }
  function y(x) {
    return "<".concat(x.data, ">");
  }
  function n(x, s) {
    var w, S = x.data || "";
    return ((w = s.encodeEntities) !== null && w !== void 0 ? w : s.decodeEntities) !== !1 && !(!s.xmlMode && x.parent && f.has(x.parent.name)) && (S = s.xmlMode || s.encodeEntities !== "utf8" ? (0, h.encodeXML)(S) : (0, h.escapeText)(S)), S;
  }
  function m(x) {
    return "<![CDATA[".concat(x.children[0].data, "]]>");
  }
  function g(x) {
    return "<!--".concat(x.data, "-->");
  }
  return se;
}
var Bu;
function Pr() {
  if (Bu) return ye;
  Bu = 1;
  var u = ye && ye.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(ye, "__esModule", { value: !0 }), ye.getOuterHTML = d, ye.getInnerHTML = h, ye.getText = a, ye.textContent = f, ye.innerText = p;
  var E = /* @__PURE__ */ Ie(), v = u(/* @__PURE__ */ di()), l = /* @__PURE__ */ ze();
  function d(i, r) {
    return (0, v.default)(i, r);
  }
  function h(i, r) {
    return (0, E.hasChildren)(i) ? i.children.map(function(c) {
      return d(c, r);
    }).join("") : "";
  }
  function a(i) {
    return Array.isArray(i) ? i.map(a).join("") : (0, E.isTag)(i) ? i.name === "br" ? `
` : a(i.children) : (0, E.isCDATA)(i) ? a(i.children) : (0, E.isText)(i) ? i.data : "";
  }
  function f(i) {
    return Array.isArray(i) ? i.map(f).join("") : (0, E.hasChildren)(i) && !(0, E.isComment)(i) ? f(i.children) : (0, E.isText)(i) ? i.data : "";
  }
  function p(i) {
    return Array.isArray(i) ? i.map(p).join("") : (0, E.hasChildren)(i) && (i.type === l.ElementType.Tag || (0, E.isCDATA)(i)) ? p(i.children) : (0, E.isText)(i) ? i.data : "";
  }
  return ye;
}
var be = {}, Uu;
function hi() {
  if (Uu) return be;
  Uu = 1, Object.defineProperty(be, "__esModule", { value: !0 }), be.getChildren = E, be.getParent = v, be.getSiblings = l, be.getAttributeValue = d, be.hasAttrib = h, be.getName = a, be.nextElementSibling = f, be.prevElementSibling = p;
  var u = /* @__PURE__ */ Ie();
  function E(i) {
    return (0, u.hasChildren)(i) ? i.children : [];
  }
  function v(i) {
    return i.parent || null;
  }
  function l(i) {
    var r, c, e = v(i);
    if (e != null)
      return E(e);
    for (var t = [i], o = i.prev, b = i.next; o != null; )
      t.unshift(o), r = o, o = r.prev;
    for (; b != null; )
      t.push(b), c = b, b = c.next;
    return t;
  }
  function d(i, r) {
    var c;
    return (c = i.attribs) === null || c === void 0 ? void 0 : c[r];
  }
  function h(i, r) {
    return i.attribs != null && Object.prototype.hasOwnProperty.call(i.attribs, r) && i.attribs[r] != null;
  }
  function a(i) {
    return i.name;
  }
  function f(i) {
    for (var r, c = i.next; c !== null && !(0, u.isTag)(c); )
      r = c, c = r.next;
    return c;
  }
  function p(i) {
    for (var r, c = i.prev; c !== null && !(0, u.isTag)(c); )
      r = c, c = r.prev;
    return c;
  }
  return be;
}
var Ae = {}, Hu;
function pi() {
  if (Hu) return Ae;
  Hu = 1, Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.removeElement = u, Ae.replaceElement = E, Ae.appendChild = v, Ae.append = l, Ae.prependChild = d, Ae.prepend = h;
  function u(a) {
    if (a.prev && (a.prev.next = a.next), a.next && (a.next.prev = a.prev), a.parent) {
      var f = a.parent.children, p = f.lastIndexOf(a);
      p >= 0 && f.splice(p, 1);
    }
    a.next = null, a.prev = null, a.parent = null;
  }
  function E(a, f) {
    var p = f.prev = a.prev;
    p && (p.next = f);
    var i = f.next = a.next;
    i && (i.prev = f);
    var r = f.parent = a.parent;
    if (r) {
      var c = r.children;
      c[c.lastIndexOf(a)] = f, a.parent = null;
    }
  }
  function v(a, f) {
    if (u(f), f.next = null, f.parent = a, a.children.push(f) > 1) {
      var p = a.children[a.children.length - 2];
      p.next = f, f.prev = p;
    } else
      f.prev = null;
  }
  function l(a, f) {
    u(f);
    var p = a.parent, i = a.next;
    if (f.next = i, f.prev = a, a.next = f, f.parent = p, i) {
      if (i.prev = f, p) {
        var r = p.children;
        r.splice(r.lastIndexOf(i), 0, f);
      }
    } else p && p.children.push(f);
  }
  function d(a, f) {
    if (u(f), f.parent = a, f.prev = null, a.children.unshift(f) !== 1) {
      var p = a.children[1];
      p.prev = f, f.next = p;
    } else
      f.next = null;
  }
  function h(a, f) {
    u(f);
    var p = a.parent;
    if (p) {
      var i = p.children;
      i.splice(i.indexOf(a), 0, f);
    }
    a.prev && (a.prev.next = f), f.parent = p, f.prev = a.prev, f.next = a, a.prev = f;
  }
  return Ae;
}
var _e = {}, Fu;
function Ir() {
  if (Fu) return _e;
  Fu = 1, Object.defineProperty(_e, "__esModule", { value: !0 }), _e.filter = E, _e.find = v, _e.findOneChild = l, _e.findOne = d, _e.existsOne = h, _e.findAll = a;
  var u = /* @__PURE__ */ Ie();
  function E(f, p, i, r) {
    return i === void 0 && (i = !0), r === void 0 && (r = 1 / 0), v(f, Array.isArray(p) ? p : [p], i, r);
  }
  function v(f, p, i, r) {
    for (var c = [], e = [Array.isArray(p) ? p : [p]], t = [0]; ; ) {
      if (t[0] >= e[0].length) {
        if (t.length === 1)
          return c;
        e.shift(), t.shift();
        continue;
      }
      var o = e[0][t[0]++];
      if (f(o) && (c.push(o), --r <= 0))
        return c;
      i && (0, u.hasChildren)(o) && o.children.length > 0 && (t.unshift(0), e.unshift(o.children));
    }
  }
  function l(f, p) {
    return p.find(f);
  }
  function d(f, p, i) {
    i === void 0 && (i = !0);
    for (var r = Array.isArray(p) ? p : [p], c = 0; c < r.length; c++) {
      var e = r[c];
      if ((0, u.isTag)(e) && f(e))
        return e;
      if (i && (0, u.hasChildren)(e) && e.children.length > 0) {
        var t = d(f, e.children, !0);
        if (t)
          return t;
      }
    }
    return null;
  }
  function h(f, p) {
    return (Array.isArray(p) ? p : [p]).some(function(i) {
      return (0, u.isTag)(i) && f(i) || (0, u.hasChildren)(i) && h(f, i.children);
    });
  }
  function a(f, p) {
    for (var i = [], r = [Array.isArray(p) ? p : [p]], c = [0]; ; ) {
      if (c[0] >= r[0].length) {
        if (r.length === 1)
          return i;
        r.shift(), c.shift();
        continue;
      }
      var e = r[0][c[0]++];
      (0, u.isTag)(e) && f(e) && i.push(e), (0, u.hasChildren)(e) && e.children.length > 0 && (c.unshift(0), r.unshift(e.children));
    }
  }
  return _e;
}
var Oe = {}, Vu;
function Dr() {
  if (Vu) return Oe;
  Vu = 1, Object.defineProperty(Oe, "__esModule", { value: !0 }), Oe.testElement = a, Oe.getElements = f, Oe.getElementById = p, Oe.getElementsByTagName = i, Oe.getElementsByClassName = r, Oe.getElementsByTagType = c;
  var u = /* @__PURE__ */ Ie(), E = /* @__PURE__ */ Ir(), v = {
    tag_name: function(e) {
      return typeof e == "function" ? function(t) {
        return (0, u.isTag)(t) && e(t.name);
      } : e === "*" ? u.isTag : function(t) {
        return (0, u.isTag)(t) && t.name === e;
      };
    },
    tag_type: function(e) {
      return typeof e == "function" ? function(t) {
        return e(t.type);
      } : function(t) {
        return t.type === e;
      };
    },
    tag_contains: function(e) {
      return typeof e == "function" ? function(t) {
        return (0, u.isText)(t) && e(t.data);
      } : function(t) {
        return (0, u.isText)(t) && t.data === e;
      };
    }
  };
  function l(e, t) {
    return typeof t == "function" ? function(o) {
      return (0, u.isTag)(o) && t(o.attribs[e]);
    } : function(o) {
      return (0, u.isTag)(o) && o.attribs[e] === t;
    };
  }
  function d(e, t) {
    return function(o) {
      return e(o) || t(o);
    };
  }
  function h(e) {
    var t = Object.keys(e).map(function(o) {
      var b = e[o];
      return Object.prototype.hasOwnProperty.call(v, o) ? v[o](b) : l(o, b);
    });
    return t.length === 0 ? null : t.reduce(d);
  }
  function a(e, t) {
    var o = h(e);
    return o ? o(t) : !0;
  }
  function f(e, t, o, b) {
    b === void 0 && (b = 1 / 0);
    var y = h(e);
    return y ? (0, E.filter)(y, t, o, b) : [];
  }
  function p(e, t, o) {
    return o === void 0 && (o = !0), Array.isArray(t) || (t = [t]), (0, E.findOne)(l("id", e), t, o);
  }
  function i(e, t, o, b) {
    return o === void 0 && (o = !0), b === void 0 && (b = 1 / 0), (0, E.filter)(v.tag_name(e), t, o, b);
  }
  function r(e, t, o, b) {
    return o === void 0 && (o = !0), b === void 0 && (b = 1 / 0), (0, E.filter)(l("class", e), t, o, b);
  }
  function c(e, t, o, b) {
    return o === void 0 && (o = !0), b === void 0 && (b = 1 / 0), (0, E.filter)(v.tag_type(e), t, o, b);
  }
  return Oe;
}
var Pe = {}, zu;
function bi() {
  if (zu) return Pe;
  zu = 1, Object.defineProperty(Pe, "__esModule", { value: !0 }), Pe.DocumentPosition = void 0, Pe.removeSubsets = E, Pe.compareDocumentPosition = l, Pe.uniqueSort = d;
  var u = /* @__PURE__ */ Ie();
  function E(h) {
    for (var a = h.length; --a >= 0; ) {
      var f = h[a];
      if (a > 0 && h.lastIndexOf(f, a - 1) >= 0) {
        h.splice(a, 1);
        continue;
      }
      for (var p = f.parent; p; p = p.parent)
        if (h.includes(p)) {
          h.splice(a, 1);
          break;
        }
    }
    return h;
  }
  var v;
  (function(h) {
    h[h.DISCONNECTED = 1] = "DISCONNECTED", h[h.PRECEDING = 2] = "PRECEDING", h[h.FOLLOWING = 4] = "FOLLOWING", h[h.CONTAINS = 8] = "CONTAINS", h[h.CONTAINED_BY = 16] = "CONTAINED_BY";
  })(v || (Pe.DocumentPosition = v = {}));
  function l(h, a) {
    var f = [], p = [];
    if (h === a)
      return 0;
    for (var i = (0, u.hasChildren)(h) ? h : h.parent; i; )
      f.unshift(i), i = i.parent;
    for (i = (0, u.hasChildren)(a) ? a : a.parent; i; )
      p.unshift(i), i = i.parent;
    for (var r = Math.min(f.length, p.length), c = 0; c < r && f[c] === p[c]; )
      c++;
    if (c === 0)
      return v.DISCONNECTED;
    var e = f[c - 1], t = e.children, o = f[c], b = p[c];
    return t.indexOf(o) > t.indexOf(b) ? e === a ? v.FOLLOWING | v.CONTAINED_BY : v.FOLLOWING : e === h ? v.PRECEDING | v.CONTAINS : v.PRECEDING;
  }
  function d(h) {
    return h = h.filter(function(a, f, p) {
      return !p.includes(a, f + 1);
    }), h.sort(function(a, f) {
      var p = l(a, f);
      return p & v.PRECEDING ? -1 : p & v.FOLLOWING ? 1 : 0;
    }), h;
  }
  return Pe;
}
var Ze = {}, $u;
function mi() {
  if ($u) return Ze;
  $u = 1, Object.defineProperty(Ze, "__esModule", { value: !0 }), Ze.getFeed = v;
  var u = /* @__PURE__ */ Pr(), E = /* @__PURE__ */ Dr();
  function v(e) {
    var t = p(c, e);
    return t ? t.name === "feed" ? l(t) : d(t) : null;
  }
  function l(e) {
    var t, o = e.children, b = {
      type: "atom",
      items: (0, E.getElementsByTagName)("entry", o).map(function(m) {
        var g, x = m.children, s = { media: f(x) };
        r(s, "id", "id", x), r(s, "title", "title", x);
        var w = (g = p("link", x)) === null || g === void 0 ? void 0 : g.attribs.href;
        w && (s.link = w);
        var S = i("summary", x) || i("content", x);
        S && (s.description = S);
        var A = i("updated", x);
        return A && (s.pubDate = new Date(A)), s;
      })
    };
    r(b, "id", "id", o), r(b, "title", "title", o);
    var y = (t = p("link", o)) === null || t === void 0 ? void 0 : t.attribs.href;
    y && (b.link = y), r(b, "description", "subtitle", o);
    var n = i("updated", o);
    return n && (b.updated = new Date(n)), r(b, "author", "email", o, !0), b;
  }
  function d(e) {
    var t, o, b = (o = (t = p("channel", e.children)) === null || t === void 0 ? void 0 : t.children) !== null && o !== void 0 ? o : [], y = {
      type: e.name.substr(0, 3),
      id: "",
      items: (0, E.getElementsByTagName)("item", e.children).map(function(m) {
        var g = m.children, x = { media: f(g) };
        r(x, "id", "guid", g), r(x, "title", "title", g), r(x, "link", "link", g), r(x, "description", "description", g);
        var s = i("pubDate", g) || i("dc:date", g);
        return s && (x.pubDate = new Date(s)), x;
      })
    };
    r(y, "title", "title", b), r(y, "link", "link", b), r(y, "description", "description", b);
    var n = i("lastBuildDate", b);
    return n && (y.updated = new Date(n)), r(y, "author", "managingEditor", b, !0), y;
  }
  var h = ["url", "type", "lang"], a = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function f(e) {
    return (0, E.getElementsByTagName)("media:content", e).map(function(t) {
      for (var o = t.attribs, b = {
        medium: o.medium,
        isDefault: !!o.isDefault
      }, y = 0, n = h; y < n.length; y++) {
        var m = n[y];
        o[m] && (b[m] = o[m]);
      }
      for (var g = 0, x = a; g < x.length; g++) {
        var m = x[g];
        o[m] && (b[m] = parseInt(o[m], 10));
      }
      return o.expression && (b.expression = o.expression), b;
    });
  }
  function p(e, t) {
    return (0, E.getElementsByTagName)(e, t, !0, 1)[0];
  }
  function i(e, t, o) {
    return o === void 0 && (o = !1), (0, u.textContent)((0, E.getElementsByTagName)(e, t, o, 1)).trim();
  }
  function r(e, t, o, b, y) {
    y === void 0 && (y = !1);
    var n = i(o, b, y);
    n && (e[t] = n);
  }
  function c(e) {
    return e === "rss" || e === "feed" || e === "rdf:RDF";
  }
  return Ze;
}
var Gu;
function St() {
  return Gu || (Gu = 1, function(u) {
    var E = Me && Me.__createBinding || (Object.create ? function(d, h, a, f) {
      f === void 0 && (f = a);
      var p = Object.getOwnPropertyDescriptor(h, a);
      (!p || ("get" in p ? !h.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return h[a];
      } }), Object.defineProperty(d, f, p);
    } : function(d, h, a, f) {
      f === void 0 && (f = a), d[f] = h[a];
    }), v = Me && Me.__exportStar || function(d, h) {
      for (var a in d) a !== "default" && !Object.prototype.hasOwnProperty.call(h, a) && E(h, d, a);
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.hasChildren = u.isDocument = u.isComment = u.isText = u.isCDATA = u.isTag = void 0, v(/* @__PURE__ */ Pr(), u), v(/* @__PURE__ */ hi(), u), v(/* @__PURE__ */ pi(), u), v(/* @__PURE__ */ Ir(), u), v(/* @__PURE__ */ Dr(), u), v(/* @__PURE__ */ bi(), u), v(/* @__PURE__ */ mi(), u);
    var l = /* @__PURE__ */ Ie();
    Object.defineProperty(u, "isTag", { enumerable: !0, get: function() {
      return l.isTag;
    } }), Object.defineProperty(u, "isCDATA", { enumerable: !0, get: function() {
      return l.isCDATA;
    } }), Object.defineProperty(u, "isText", { enumerable: !0, get: function() {
      return l.isText;
    } }), Object.defineProperty(u, "isComment", { enumerable: !0, get: function() {
      return l.isComment;
    } }), Object.defineProperty(u, "isDocument", { enumerable: !0, get: function() {
      return l.isDocument;
    } }), Object.defineProperty(u, "hasChildren", { enumerable: !0, get: function() {
      return l.hasChildren;
    } });
  }(Me)), Me;
}
var Wu;
function gi() {
  return Wu || (Wu = 1, function(u) {
    var E = de && de.__createBinding || (Object.create ? function(n, m, g, x) {
      x === void 0 && (x = g);
      var s = Object.getOwnPropertyDescriptor(m, g);
      (!s || ("get" in s ? !m.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return m[g];
      } }), Object.defineProperty(n, x, s);
    } : function(n, m, g, x) {
      x === void 0 && (x = g), n[x] = m[g];
    }), v = de && de.__setModuleDefault || (Object.create ? function(n, m) {
      Object.defineProperty(n, "default", { enumerable: !0, value: m });
    } : function(n, m) {
      n.default = m;
    }), l = de && de.__importStar || function(n) {
      if (n && n.__esModule) return n;
      var m = {};
      if (n != null) for (var g in n) g !== "default" && Object.prototype.hasOwnProperty.call(n, g) && E(m, n, g);
      return v(m, n), m;
    }, d = de && de.__importDefault || function(n) {
      return n && n.__esModule ? n : { default: n };
    };
    Object.defineProperty(u, "__esModule", { value: !0 }), u.DomUtils = u.parseFeed = u.getFeed = u.ElementType = u.Tokenizer = u.createDomStream = u.parseDOM = u.parseDocument = u.DefaultHandler = u.DomHandler = u.Parser = void 0;
    var h = /* @__PURE__ */ Ou(), a = /* @__PURE__ */ Ou();
    Object.defineProperty(u, "Parser", { enumerable: !0, get: function() {
      return a.Parser;
    } });
    var f = /* @__PURE__ */ Ie(), p = /* @__PURE__ */ Ie();
    Object.defineProperty(u, "DomHandler", { enumerable: !0, get: function() {
      return p.DomHandler;
    } }), Object.defineProperty(u, "DefaultHandler", { enumerable: !0, get: function() {
      return p.DomHandler;
    } });
    function i(n, m) {
      var g = new f.DomHandler(void 0, m);
      return new h.Parser(g, m).end(n), g.root;
    }
    u.parseDocument = i;
    function r(n, m) {
      return i(n, m).children;
    }
    u.parseDOM = r;
    function c(n, m, g) {
      var x = new f.DomHandler(n, m, g);
      return new h.Parser(x, m);
    }
    u.createDomStream = c;
    var e = /* @__PURE__ */ Rr();
    Object.defineProperty(u, "Tokenizer", { enumerable: !0, get: function() {
      return d(e).default;
    } }), u.ElementType = l(/* @__PURE__ */ ze());
    var t = /* @__PURE__ */ St(), o = /* @__PURE__ */ St();
    Object.defineProperty(u, "getFeed", { enumerable: !0, get: function() {
      return o.getFeed;
    } });
    var b = { xmlMode: !0 };
    function y(n, m) {
      return m === void 0 && (m = b), (0, t.getFeed)(r(n, m));
    }
    u.parseFeed = y, u.DomUtils = l(/* @__PURE__ */ St());
  }(de)), de;
}
var Tt, Yu;
function yi() {
  return Yu || (Yu = 1, Tt = (u) => {
    if (typeof u != "string")
      throw new TypeError("Expected a string");
    return u.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), Tt;
}
var Ke = {}, Ju;
function vi() {
  if (Ju) return Ke;
  Ju = 1, Object.defineProperty(Ke, "__esModule", { value: !0 });
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function u(v) {
    return Object.prototype.toString.call(v) === "[object Object]";
  }
  function E(v) {
    var l, d;
    return u(v) === !1 ? !1 : (l = v.constructor, l === void 0 ? !0 : (d = l.prototype, !(u(d) === !1 || d.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return Ke.isPlainObject = E, Ke;
}
var At, Xu;
function xi() {
  if (Xu) return At;
  Xu = 1;
  var u = function(m) {
    return E(m) && !v(m);
  };
  function E(n) {
    return !!n && typeof n == "object";
  }
  function v(n) {
    var m = Object.prototype.toString.call(n);
    return m === "[object RegExp]" || m === "[object Date]" || h(n);
  }
  var l = typeof Symbol == "function" && Symbol.for, d = l ? Symbol.for("react.element") : 60103;
  function h(n) {
    return n.$$typeof === d;
  }
  function a(n) {
    return Array.isArray(n) ? [] : {};
  }
  function f(n, m) {
    return m.clone !== !1 && m.isMergeableObject(n) ? b(a(n), n, m) : n;
  }
  function p(n, m, g) {
    return n.concat(m).map(function(x) {
      return f(x, g);
    });
  }
  function i(n, m) {
    if (!m.customMerge)
      return b;
    var g = m.customMerge(n);
    return typeof g == "function" ? g : b;
  }
  function r(n) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n).filter(function(m) {
      return Object.propertyIsEnumerable.call(n, m);
    }) : [];
  }
  function c(n) {
    return Object.keys(n).concat(r(n));
  }
  function e(n, m) {
    try {
      return m in n;
    } catch {
      return !1;
    }
  }
  function t(n, m) {
    return e(n, m) && !(Object.hasOwnProperty.call(n, m) && Object.propertyIsEnumerable.call(n, m));
  }
  function o(n, m, g) {
    var x = {};
    return g.isMergeableObject(n) && c(n).forEach(function(s) {
      x[s] = f(n[s], g);
    }), c(m).forEach(function(s) {
      t(n, s) || (e(n, s) && g.isMergeableObject(m[s]) ? x[s] = i(s, g)(n[s], m[s], g) : x[s] = f(m[s], g));
    }), x;
  }
  function b(n, m, g) {
    g = g || {}, g.arrayMerge = g.arrayMerge || p, g.isMergeableObject = g.isMergeableObject || u, g.cloneUnlessOtherwiseSpecified = f;
    var x = Array.isArray(m), s = Array.isArray(n), w = x === s;
    return w ? x ? g.arrayMerge(n, m, g) : o(n, m, g) : f(m, g);
  }
  b.all = function(m, g) {
    if (!Array.isArray(m))
      throw new Error("first argument should be an array");
    return m.reduce(function(x, s) {
      return b(x, s, g);
    }, {});
  };
  var y = b;
  return At = y, At;
}
var ut = { exports: {} }, wi = ut.exports, Qu;
function Ei() {
  return Qu || (Qu = 1, function(u) {
    (function(E, v) {
      u.exports ? u.exports = v() : E.parseSrcset = v();
    })(wi, function() {
      return function(E) {
        function v(x) {
          return x === " " || // space
          x === "	" || // horizontal tab
          x === `
` || // new line
          x === "\f" || // form feed
          x === "\r";
        }
        function l(x) {
          var s, w = x.exec(E.substring(y));
          if (w)
            return s = w[0], y += s.length, s;
        }
        for (var d = E.length, h = /^[ \t\n\r\u000c]+/, a = /^[, \t\n\r\u000c]+/, f = /^[^ \t\n\r\u000c]+/, p = /[,]+$/, i = /^\d+$/, r = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, c, e, t, o, b, y = 0, n = []; ; ) {
          if (l(a), y >= d)
            return n;
          c = l(f), e = [], c.slice(-1) === "," ? (c = c.replace(p, ""), g()) : m();
        }
        function m() {
          for (l(h), t = "", o = "in descriptor"; ; ) {
            if (b = E.charAt(y), o === "in descriptor")
              if (v(b))
                t && (e.push(t), t = "", o = "after descriptor");
              else if (b === ",") {
                y += 1, t && e.push(t), g();
                return;
              } else if (b === "(")
                t = t + b, o = "in parens";
              else if (b === "") {
                t && e.push(t), g();
                return;
              } else
                t = t + b;
            else if (o === "in parens")
              if (b === ")")
                t = t + b, o = "in descriptor";
              else if (b === "") {
                e.push(t), g();
                return;
              } else
                t = t + b;
            else if (o === "after descriptor" && !v(b))
              if (b === "") {
                g();
                return;
              } else
                o = "in descriptor", y -= 1;
            y += 1;
          }
        }
        function g() {
          var x = !1, s, w, S, A, P = {}, R, _, O, q, M;
          for (A = 0; A < e.length; A++)
            R = e[A], _ = R[R.length - 1], O = R.substring(0, R.length - 1), q = parseInt(O, 10), M = parseFloat(O), i.test(O) && _ === "w" ? ((s || w) && (x = !0), q === 0 ? x = !0 : s = q) : r.test(O) && _ === "x" ? ((s || w || S) && (x = !0), M < 0 ? x = !0 : w = M) : i.test(O) && _ === "h" ? ((S || w) && (x = !0), q === 0 ? x = !0 : S = q) : x = !0;
          x ? console && console.log && console.log("Invalid srcset descriptor found in '" + E + "' at '" + R + "'.") : (P.url = c, s && (P.w = s), w && (P.d = w), S && (P.h = S), n.push(P));
        }
      };
    });
  }(ut)), ut.exports;
}
var et = { exports: {} }, Zu;
function Si() {
  if (Zu) return et.exports;
  Zu = 1;
  var u = String, E = function() {
    return { isColorSupported: !1, reset: u, bold: u, dim: u, italic: u, underline: u, inverse: u, hidden: u, strikethrough: u, black: u, red: u, green: u, yellow: u, blue: u, magenta: u, cyan: u, white: u, gray: u, bgBlack: u, bgRed: u, bgGreen: u, bgYellow: u, bgBlue: u, bgMagenta: u, bgCyan: u, bgWhite: u, blackBright: u, redBright: u, greenBright: u, yellowBright: u, blueBright: u, magentaBright: u, cyanBright: u, whiteBright: u, bgBlackBright: u, bgRedBright: u, bgGreenBright: u, bgYellowBright: u, bgBlueBright: u, bgMagentaBright: u, bgCyanBright: u, bgWhiteBright: u };
  };
  return et.exports = E(), et.exports.createColors = E, et.exports;
}
const Ti = {}, Ai = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ti
}, Symbol.toStringTag, { value: "Module" })), me = /* @__PURE__ */ ri(Ai);
var _t, Ku;
function tu() {
  if (Ku) return _t;
  Ku = 1;
  let u = /* @__PURE__ */ Si(), E = me;
  class v extends Error {
    constructor(d, h, a, f, p, i) {
      super(d), this.name = "CssSyntaxError", this.reason = d, p && (this.file = p), f && (this.source = f), i && (this.plugin = i), typeof h < "u" && typeof a < "u" && (typeof h == "number" ? (this.line = h, this.column = a) : (this.line = h.line, this.column = h.column, this.endLine = a.line, this.endColumn = a.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, v);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(d) {
      if (!this.source) return "";
      let h = this.source;
      d == null && (d = u.isColorSupported);
      let a = (t) => t, f = (t) => t, p = (t) => t;
      if (d) {
        let { bold: t, gray: o, red: b } = u.createColors(!0);
        f = (y) => t(b(y)), a = (y) => o(y), E && (p = (y) => E(y));
      }
      let i = h.split(/\r?\n/), r = Math.max(this.line - 3, 0), c = Math.min(this.line + 2, i.length), e = String(c).length;
      return i.slice(r, c).map((t, o) => {
        let b = r + 1 + o, y = " " + (" " + b).slice(-e) + " | ";
        if (b === this.line) {
          if (t.length > 160) {
            let m = 20, g = Math.max(0, this.column - m), x = Math.max(
              this.column + m,
              this.endColumn + m
            ), s = t.slice(g, x), w = a(y.replace(/\d/g, " ")) + t.slice(0, Math.min(this.column - 1, m - 1)).replace(/[^\t]/g, " ");
            return f(">") + a(y) + p(s) + `
 ` + w + f("^");
          }
          let n = a(y.replace(/\d/g, " ")) + t.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return f(">") + a(y) + p(t) + `
 ` + n + f("^");
        }
        return " " + a(y) + p(t);
      }).join(`
`);
    }
    toString() {
      let d = this.showSourceCode();
      return d && (d = `

` + d + `
`), this.name + ": " + this.message + d;
    }
  }
  return _t = v, v.default = v, _t;
}
var Ot, er;
function qr() {
  if (er) return Ot;
  er = 1;
  const u = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function E(l) {
    return l[0].toUpperCase() + l.slice(1);
  }
  class v {
    constructor(d) {
      this.builder = d;
    }
    atrule(d, h) {
      let a = "@" + d.name, f = d.params ? this.rawValue(d, "params") : "";
      if (typeof d.raws.afterName < "u" ? a += d.raws.afterName : f && (a += " "), d.nodes)
        this.block(d, a + f);
      else {
        let p = (d.raws.between || "") + (h ? ";" : "");
        this.builder(a + f + p, d);
      }
    }
    beforeAfter(d, h) {
      let a;
      d.type === "decl" ? a = this.raw(d, null, "beforeDecl") : d.type === "comment" ? a = this.raw(d, null, "beforeComment") : h === "before" ? a = this.raw(d, null, "beforeRule") : a = this.raw(d, null, "beforeClose");
      let f = d.parent, p = 0;
      for (; f && f.type !== "root"; )
        p += 1, f = f.parent;
      if (a.includes(`
`)) {
        let i = this.raw(d, null, "indent");
        if (i.length)
          for (let r = 0; r < p; r++) a += i;
      }
      return a;
    }
    block(d, h) {
      let a = this.raw(d, "between", "beforeOpen");
      this.builder(h + a + "{", d, "start");
      let f;
      d.nodes && d.nodes.length ? (this.body(d), f = this.raw(d, "after")) : f = this.raw(d, "after", "emptyBody"), f && this.builder(f), this.builder("}", d, "end");
    }
    body(d) {
      let h = d.nodes.length - 1;
      for (; h > 0 && d.nodes[h].type === "comment"; )
        h -= 1;
      let a = this.raw(d, "semicolon");
      for (let f = 0; f < d.nodes.length; f++) {
        let p = d.nodes[f], i = this.raw(p, "before");
        i && this.builder(i), this.stringify(p, h !== f || a);
      }
    }
    comment(d) {
      let h = this.raw(d, "left", "commentLeft"), a = this.raw(d, "right", "commentRight");
      this.builder("/*" + h + d.text + a + "*/", d);
    }
    decl(d, h) {
      let a = this.raw(d, "between", "colon"), f = d.prop + a + this.rawValue(d, "value");
      d.important && (f += d.raws.important || " !important"), h && (f += ";"), this.builder(f, d);
    }
    document(d) {
      this.body(d);
    }
    raw(d, h, a) {
      let f;
      if (a || (a = h), h && (f = d.raws[h], typeof f < "u"))
        return f;
      let p = d.parent;
      if (a === "before" && (!p || p.type === "root" && p.first === d || p && p.type === "document"))
        return "";
      if (!p) return u[a];
      let i = d.root();
      if (i.rawCache || (i.rawCache = {}), typeof i.rawCache[a] < "u")
        return i.rawCache[a];
      if (a === "before" || a === "after")
        return this.beforeAfter(d, a);
      {
        let r = "raw" + E(a);
        this[r] ? f = this[r](i, d) : i.walk((c) => {
          if (f = c.raws[h], typeof f < "u") return !1;
        });
      }
      return typeof f > "u" && (f = u[a]), i.rawCache[a] = f, f;
    }
    rawBeforeClose(d) {
      let h;
      return d.walk((a) => {
        if (a.nodes && a.nodes.length > 0 && typeof a.raws.after < "u")
          return h = a.raws.after, h.includes(`
`) && (h = h.replace(/[^\n]+$/, "")), !1;
      }), h && (h = h.replace(/\S/g, "")), h;
    }
    rawBeforeComment(d, h) {
      let a;
      return d.walkComments((f) => {
        if (typeof f.raws.before < "u")
          return a = f.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(h, null, "beforeDecl") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeDecl(d, h) {
      let a;
      return d.walkDecls((f) => {
        if (typeof f.raws.before < "u")
          return a = f.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), typeof a > "u" ? a = this.raw(h, null, "beforeRule") : a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeOpen(d) {
      let h;
      return d.walk((a) => {
        if (a.type !== "decl" && (h = a.raws.between, typeof h < "u"))
          return !1;
      }), h;
    }
    rawBeforeRule(d) {
      let h;
      return d.walk((a) => {
        if (a.nodes && (a.parent !== d || d.first !== a) && typeof a.raws.before < "u")
          return h = a.raws.before, h.includes(`
`) && (h = h.replace(/[^\n]+$/, "")), !1;
      }), h && (h = h.replace(/\S/g, "")), h;
    }
    rawColon(d) {
      let h;
      return d.walkDecls((a) => {
        if (typeof a.raws.between < "u")
          return h = a.raws.between.replace(/[^\s:]/g, ""), !1;
      }), h;
    }
    rawEmptyBody(d) {
      let h;
      return d.walk((a) => {
        if (a.nodes && a.nodes.length === 0 && (h = a.raws.after, typeof h < "u"))
          return !1;
      }), h;
    }
    rawIndent(d) {
      if (d.raws.indent) return d.raws.indent;
      let h;
      return d.walk((a) => {
        let f = a.parent;
        if (f && f !== d && f.parent && f.parent === d && typeof a.raws.before < "u") {
          let p = a.raws.before.split(`
`);
          return h = p[p.length - 1], h = h.replace(/\S/g, ""), !1;
        }
      }), h;
    }
    rawSemicolon(d) {
      let h;
      return d.walk((a) => {
        if (a.nodes && a.nodes.length && a.last.type === "decl" && (h = a.raws.semicolon, typeof h < "u"))
          return !1;
      }), h;
    }
    rawValue(d, h) {
      let a = d[h], f = d.raws[h];
      return f && f.value === a ? f.raw : a;
    }
    root(d) {
      this.body(d), d.raws.after && this.builder(d.raws.after);
    }
    rule(d) {
      this.block(d, this.rawValue(d, "selector")), d.raws.ownSemicolon && this.builder(d.raws.ownSemicolon, d, "end");
    }
    stringify(d, h) {
      if (!this[d.type])
        throw new Error(
          "Unknown AST node type " + d.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[d.type](d, h);
    }
  }
  return Ot = v, v.default = v, Ot;
}
var Nt, tr;
function nt() {
  if (tr) return Nt;
  tr = 1;
  let u = qr();
  function E(v, l) {
    new u(l).stringify(v);
  }
  return Nt = E, E.default = E, Nt;
}
var tt = {}, ur;
function uu() {
  return ur || (ur = 1, tt.isClean = Symbol("isClean"), tt.my = Symbol("my")), tt;
}
var Ct, rr;
function at() {
  if (rr) return Ct;
  rr = 1;
  let u = tu(), E = qr(), v = nt(), { isClean: l, my: d } = uu();
  function h(p, i) {
    let r = new p.constructor();
    for (let c in p) {
      if (!Object.prototype.hasOwnProperty.call(p, c) || c === "proxyCache") continue;
      let e = p[c], t = typeof e;
      c === "parent" && t === "object" ? i && (r[c] = i) : c === "source" ? r[c] = e : Array.isArray(e) ? r[c] = e.map((o) => h(o, r)) : (t === "object" && e !== null && (e = h(e)), r[c] = e);
    }
    return r;
  }
  function a(p, i) {
    if (i && typeof i.offset < "u")
      return i.offset;
    let r = 1, c = 1, e = 0;
    for (let t = 0; t < p.length; t++) {
      if (c === i.line && r === i.column) {
        e = t;
        break;
      }
      p[t] === `
` ? (r = 1, c += 1) : r += 1;
    }
    return e;
  }
  class f {
    get proxyOf() {
      return this;
    }
    constructor(i = {}) {
      this.raws = {}, this[l] = !1, this[d] = !0;
      for (let r in i)
        if (r === "nodes") {
          this.nodes = [];
          for (let c of i[r])
            typeof c.clone == "function" ? this.append(c.clone()) : this.append(c);
        } else
          this[r] = i[r];
    }
    addToError(i) {
      if (i.postcssNode = this, i.stack && this.source && /\n\s{4}at /.test(i.stack)) {
        let r = this.source;
        i.stack = i.stack.replace(
          /\n\s{4}at /,
          `$&${r.input.from}:${r.start.line}:${r.start.column}$&`
        );
      }
      return i;
    }
    after(i) {
      return this.parent.insertAfter(this, i), this;
    }
    assign(i = {}) {
      for (let r in i)
        this[r] = i[r];
      return this;
    }
    before(i) {
      return this.parent.insertBefore(this, i), this;
    }
    cleanRaws(i) {
      delete this.raws.before, delete this.raws.after, i || delete this.raws.between;
    }
    clone(i = {}) {
      let r = h(this);
      for (let c in i)
        r[c] = i[c];
      return r;
    }
    cloneAfter(i = {}) {
      let r = this.clone(i);
      return this.parent.insertAfter(this, r), r;
    }
    cloneBefore(i = {}) {
      let r = this.clone(i);
      return this.parent.insertBefore(this, r), r;
    }
    error(i, r = {}) {
      if (this.source) {
        let { end: c, start: e } = this.rangeBy(r);
        return this.source.input.error(
          i,
          { column: e.column, line: e.line },
          { column: c.column, line: c.line },
          r
        );
      }
      return new u(i);
    }
    getProxyProcessor() {
      return {
        get(i, r) {
          return r === "proxyOf" ? i : r === "root" ? () => i.root().toProxy() : i[r];
        },
        set(i, r, c) {
          return i[r] === c || (i[r] = c, (r === "prop" || r === "value" || r === "name" || r === "params" || r === "important" || /* c8 ignore next */
          r === "text") && i.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[l] = !0;
    }
    markDirty() {
      if (this[l]) {
        this[l] = !1;
        let i = this;
        for (; i = i.parent; )
          i[l] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let i = this.parent.index(this);
      return this.parent.nodes[i + 1];
    }
    positionBy(i) {
      let r = this.source.start;
      if (i.index)
        r = this.positionInside(i.index);
      else if (i.word) {
        let c = "document" in this.source.input ? this.source.input.document : this.source.input.css, t = c.slice(
          a(c, this.source.start),
          a(c, this.source.end)
        ).indexOf(i.word);
        t !== -1 && (r = this.positionInside(t));
      }
      return r;
    }
    positionInside(i) {
      let r = this.source.start.column, c = this.source.start.line, e = "document" in this.source.input ? this.source.input.document : this.source.input.css, t = a(e, this.source.start), o = t + i;
      for (let b = t; b < o; b++)
        e[b] === `
` ? (r = 1, c += 1) : r += 1;
      return { column: r, line: c };
    }
    prev() {
      if (!this.parent) return;
      let i = this.parent.index(this);
      return this.parent.nodes[i - 1];
    }
    rangeBy(i) {
      let r = {
        column: this.source.start.column,
        line: this.source.start.line
      }, c = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line
      } : {
        column: r.column + 1,
        line: r.line
      };
      if (i.word) {
        let e = "document" in this.source.input ? this.source.input.document : this.source.input.css, o = e.slice(
          a(e, this.source.start),
          a(e, this.source.end)
        ).indexOf(i.word);
        o !== -1 && (r = this.positionInside(o), c = this.positionInside(
          o + i.word.length
        ));
      } else
        i.start ? r = {
          column: i.start.column,
          line: i.start.line
        } : i.index && (r = this.positionInside(i.index)), i.end ? c = {
          column: i.end.column,
          line: i.end.line
        } : typeof i.endIndex == "number" ? c = this.positionInside(i.endIndex) : i.index && (c = this.positionInside(i.index + 1));
      return (c.line < r.line || c.line === r.line && c.column <= r.column) && (c = { column: r.column + 1, line: r.line }), { end: c, start: r };
    }
    raw(i, r) {
      return new E().raw(this, i, r);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...i) {
      if (this.parent) {
        let r = this, c = !1;
        for (let e of i)
          e === this ? c = !0 : c ? (this.parent.insertAfter(r, e), r = e) : this.parent.insertBefore(r, e);
        c || this.remove();
      }
      return this;
    }
    root() {
      let i = this;
      for (; i.parent && i.parent.type !== "document"; )
        i = i.parent;
      return i;
    }
    toJSON(i, r) {
      let c = {}, e = r == null;
      r = r || /* @__PURE__ */ new Map();
      let t = 0;
      for (let o in this) {
        if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
        let b = this[o];
        if (Array.isArray(b))
          c[o] = b.map((y) => typeof y == "object" && y.toJSON ? y.toJSON(null, r) : y);
        else if (typeof b == "object" && b.toJSON)
          c[o] = b.toJSON(null, r);
        else if (o === "source") {
          let y = r.get(b.input);
          y == null && (y = t, r.set(b.input, t), t++), c[o] = {
            end: b.end,
            inputId: y,
            start: b.start
          };
        } else
          c[o] = b;
      }
      return e && (c.inputs = [...r.keys()].map((o) => o.toJSON())), c;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(i = v) {
      i.stringify && (i = i.stringify);
      let r = "";
      return i(this, (c) => {
        r += c;
      }), r;
    }
    warn(i, r, c) {
      let e = { node: this };
      for (let t in c) e[t] = c[t];
      return i.warn(r, e);
    }
  }
  return Ct = f, f.default = f, Ct;
}
var Rt, ir;
function st() {
  if (ir) return Rt;
  ir = 1;
  let u = at();
  class E extends u {
    constructor(l) {
      super(l), this.type = "comment";
    }
  }
  return Rt = E, E.default = E, Rt;
}
var Pt, nr;
function ot() {
  if (nr) return Pt;
  nr = 1;
  let u = at();
  class E extends u {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(l) {
      l && typeof l.value < "u" && typeof l.value != "string" && (l = { ...l, value: String(l.value) }), super(l), this.type = "decl";
    }
  }
  return Pt = E, E.default = E, Pt;
}
var It, ar;
function je() {
  if (ar) return It;
  ar = 1;
  let u = st(), E = ot(), v = at(), { isClean: l, my: d } = uu(), h, a, f, p;
  function i(e) {
    return e.map((t) => (t.nodes && (t.nodes = i(t.nodes)), delete t.source, t));
  }
  function r(e) {
    if (e[l] = !1, e.proxyOf.nodes)
      for (let t of e.proxyOf.nodes)
        r(t);
  }
  class c extends v {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...t) {
      for (let o of t) {
        let b = this.normalize(o, this.last);
        for (let y of b) this.proxyOf.nodes.push(y);
      }
      return this.markDirty(), this;
    }
    cleanRaws(t) {
      if (super.cleanRaws(t), this.nodes)
        for (let o of this.nodes) o.cleanRaws(t);
    }
    each(t) {
      if (!this.proxyOf.nodes) return;
      let o = this.getIterator(), b, y;
      for (; this.indexes[o] < this.proxyOf.nodes.length && (b = this.indexes[o], y = t(this.proxyOf.nodes[b], b), y !== !1); )
        this.indexes[o] += 1;
      return delete this.indexes[o], y;
    }
    every(t) {
      return this.nodes.every(t);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let t = this.lastEach;
      return this.indexes[t] = 0, t;
    }
    getProxyProcessor() {
      return {
        get(t, o) {
          return o === "proxyOf" ? t : t[o] ? o === "each" || typeof o == "string" && o.startsWith("walk") ? (...b) => t[o](
            ...b.map((y) => typeof y == "function" ? (n, m) => y(n.toProxy(), m) : y)
          ) : o === "every" || o === "some" ? (b) => t[o](
            (y, ...n) => b(y.toProxy(), ...n)
          ) : o === "root" ? () => t.root().toProxy() : o === "nodes" ? t.nodes.map((b) => b.toProxy()) : o === "first" || o === "last" ? t[o].toProxy() : t[o] : t[o];
        },
        set(t, o, b) {
          return t[o] === b || (t[o] = b, (o === "name" || o === "params" || o === "selector") && t.markDirty()), !0;
        }
      };
    }
    index(t) {
      return typeof t == "number" ? t : (t.proxyOf && (t = t.proxyOf), this.proxyOf.nodes.indexOf(t));
    }
    insertAfter(t, o) {
      let b = this.index(t), y = this.normalize(o, this.proxyOf.nodes[b]).reverse();
      b = this.index(t);
      for (let m of y) this.proxyOf.nodes.splice(b + 1, 0, m);
      let n;
      for (let m in this.indexes)
        n = this.indexes[m], b < n && (this.indexes[m] = n + y.length);
      return this.markDirty(), this;
    }
    insertBefore(t, o) {
      let b = this.index(t), y = b === 0 ? "prepend" : !1, n = this.normalize(
        o,
        this.proxyOf.nodes[b],
        y
      ).reverse();
      b = this.index(t);
      for (let g of n) this.proxyOf.nodes.splice(b, 0, g);
      let m;
      for (let g in this.indexes)
        m = this.indexes[g], b <= m && (this.indexes[g] = m + n.length);
      return this.markDirty(), this;
    }
    normalize(t, o) {
      if (typeof t == "string")
        t = i(a(t).nodes);
      else if (typeof t > "u")
        t = [];
      else if (Array.isArray(t)) {
        t = t.slice(0);
        for (let y of t)
          y.parent && y.parent.removeChild(y, "ignore");
      } else if (t.type === "root" && this.type !== "document") {
        t = t.nodes.slice(0);
        for (let y of t)
          y.parent && y.parent.removeChild(y, "ignore");
      } else if (t.type)
        t = [t];
      else if (t.prop) {
        if (typeof t.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof t.value != "string" && (t.value = String(t.value)), t = [new E(t)];
      } else if (t.selector || t.selectors)
        t = [new p(t)];
      else if (t.name)
        t = [new h(t)];
      else if (t.text)
        t = [new u(t)];
      else
        throw new Error("Unknown node type in node creation");
      return t.map((y) => (y[d] || c.rebuild(y), y = y.proxyOf, y.parent && y.parent.removeChild(y), y[l] && r(y), y.raws || (y.raws = {}), typeof y.raws.before > "u" && o && typeof o.raws.before < "u" && (y.raws.before = o.raws.before.replace(/\S/g, "")), y.parent = this.proxyOf, y));
    }
    prepend(...t) {
      t = t.reverse();
      for (let o of t) {
        let b = this.normalize(o, this.first, "prepend").reverse();
        for (let y of b) this.proxyOf.nodes.unshift(y);
        for (let y in this.indexes)
          this.indexes[y] = this.indexes[y] + b.length;
      }
      return this.markDirty(), this;
    }
    push(t) {
      return t.parent = this, this.proxyOf.nodes.push(t), this;
    }
    removeAll() {
      for (let t of this.proxyOf.nodes) t.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(t) {
      t = this.index(t), this.proxyOf.nodes[t].parent = void 0, this.proxyOf.nodes.splice(t, 1);
      let o;
      for (let b in this.indexes)
        o = this.indexes[b], o >= t && (this.indexes[b] = o - 1);
      return this.markDirty(), this;
    }
    replaceValues(t, o, b) {
      return b || (b = o, o = {}), this.walkDecls((y) => {
        o.props && !o.props.includes(y.prop) || o.fast && !y.value.includes(o.fast) || (y.value = y.value.replace(t, b));
      }), this.markDirty(), this;
    }
    some(t) {
      return this.nodes.some(t);
    }
    walk(t) {
      return this.each((o, b) => {
        let y;
        try {
          y = t(o, b);
        } catch (n) {
          throw o.addToError(n);
        }
        return y !== !1 && o.walk && (y = o.walk(t)), y;
      });
    }
    walkAtRules(t, o) {
      return o ? t instanceof RegExp ? this.walk((b, y) => {
        if (b.type === "atrule" && t.test(b.name))
          return o(b, y);
      }) : this.walk((b, y) => {
        if (b.type === "atrule" && b.name === t)
          return o(b, y);
      }) : (o = t, this.walk((b, y) => {
        if (b.type === "atrule")
          return o(b, y);
      }));
    }
    walkComments(t) {
      return this.walk((o, b) => {
        if (o.type === "comment")
          return t(o, b);
      });
    }
    walkDecls(t, o) {
      return o ? t instanceof RegExp ? this.walk((b, y) => {
        if (b.type === "decl" && t.test(b.prop))
          return o(b, y);
      }) : this.walk((b, y) => {
        if (b.type === "decl" && b.prop === t)
          return o(b, y);
      }) : (o = t, this.walk((b, y) => {
        if (b.type === "decl")
          return o(b, y);
      }));
    }
    walkRules(t, o) {
      return o ? t instanceof RegExp ? this.walk((b, y) => {
        if (b.type === "rule" && t.test(b.selector))
          return o(b, y);
      }) : this.walk((b, y) => {
        if (b.type === "rule" && b.selector === t)
          return o(b, y);
      }) : (o = t, this.walk((b, y) => {
        if (b.type === "rule")
          return o(b, y);
      }));
    }
  }
  return c.registerParse = (e) => {
    a = e;
  }, c.registerRule = (e) => {
    p = e;
  }, c.registerAtRule = (e) => {
    h = e;
  }, c.registerRoot = (e) => {
    f = e;
  }, It = c, c.default = c, c.rebuild = (e) => {
    e.type === "atrule" ? Object.setPrototypeOf(e, h.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, p.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, E.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, u.prototype) : e.type === "root" && Object.setPrototypeOf(e, f.prototype), e[d] = !0, e.nodes && e.nodes.forEach((t) => {
      c.rebuild(t);
    });
  }, It;
}
var Dt, sr;
function ru() {
  if (sr) return Dt;
  sr = 1;
  let u = je();
  class E extends u {
    constructor(l) {
      super(l), this.type = "atrule";
    }
    append(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...l);
    }
    prepend(...l) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...l);
    }
  }
  return Dt = E, E.default = E, u.registerAtRule(E), Dt;
}
var qt, or;
function iu() {
  if (or) return qt;
  or = 1;
  let u = je(), E, v;
  class l extends u {
    constructor(h) {
      super({ type: "document", ...h }), this.nodes || (this.nodes = []);
    }
    toResult(h = {}) {
      return new E(new v(), this, h).stringify();
    }
  }
  return l.registerLazyResult = (d) => {
    E = d;
  }, l.registerProcessor = (d) => {
    v = d;
  }, qt = l, l.default = l, qt;
}
var Lt, cr;
function _i() {
  if (cr) return Lt;
  cr = 1;
  let u = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return Lt = { nanoid: (l = 21) => {
    let d = "", h = l | 0;
    for (; h--; )
      d += u[Math.random() * 64 | 0];
    return d;
  }, customAlphabet: (l, d = 21) => (h = d) => {
    let a = "", f = h | 0;
    for (; f--; )
      a += l[Math.random() * l.length | 0];
    return a;
  } }, Lt;
}
var Mt, lr;
function Lr() {
  if (lr) return Mt;
  lr = 1;
  let { existsSync: u, readFileSync: E } = me, { dirname: v, join: l } = me, { SourceMapConsumer: d, SourceMapGenerator: h } = me;
  function a(p) {
    return Buffer ? Buffer.from(p, "base64").toString() : window.atob(p);
  }
  class f {
    constructor(i, r) {
      if (r.map === !1) return;
      this.loadAnnotation(i), this.inline = this.startWith(this.annotation, "data:");
      let c = r.map ? r.map.prev : void 0, e = this.loadMap(r.from, c);
      !this.mapFile && r.from && (this.mapFile = r.from), this.mapFile && (this.root = v(this.mapFile)), e && (this.text = e);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new d(this.text)), this.consumerCache;
    }
    decodeInline(i) {
      let r = /^data:application\/json;charset=utf-?8;base64,/, c = /^data:application\/json;base64,/, e = /^data:application\/json;charset=utf-?8,/, t = /^data:application\/json,/, o = i.match(e) || i.match(t);
      if (o)
        return decodeURIComponent(i.substr(o[0].length));
      let b = i.match(r) || i.match(c);
      if (b)
        return a(i.substr(b[0].length));
      let y = i.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + y);
    }
    getAnnotationURL(i) {
      return i.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(i) {
      return typeof i != "object" ? !1 : typeof i.mappings == "string" || typeof i._mappings == "string" || Array.isArray(i.sections);
    }
    loadAnnotation(i) {
      let r = i.match(/\/\*\s*# sourceMappingURL=/g);
      if (!r) return;
      let c = i.lastIndexOf(r.pop()), e = i.indexOf("*/", c);
      c > -1 && e > -1 && (this.annotation = this.getAnnotationURL(i.substring(c, e)));
    }
    loadFile(i) {
      if (this.root = v(i), u(i))
        return this.mapFile = i, E(i, "utf-8").toString().trim();
    }
    loadMap(i, r) {
      if (r === !1) return !1;
      if (r) {
        if (typeof r == "string")
          return r;
        if (typeof r == "function") {
          let c = r(i);
          if (c) {
            let e = this.loadFile(c);
            if (!e)
              throw new Error(
                "Unable to load previous source map: " + c.toString()
              );
            return e;
          }
        } else {
          if (r instanceof d)
            return h.fromSourceMap(r).toString();
          if (r instanceof h)
            return r.toString();
          if (this.isMap(r))
            return JSON.stringify(r);
          throw new Error(
            "Unsupported previous source map format: " + r.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let c = this.annotation;
          return i && (c = l(v(i), c)), this.loadFile(c);
        }
      }
    }
    startWith(i, r) {
      return i ? i.substr(0, r.length) === r : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return Mt = f, f.default = f, Mt;
}
var kt, fr;
function ct() {
  if (fr) return kt;
  fr = 1;
  let { nanoid: u } = /* @__PURE__ */ _i(), { isAbsolute: E, resolve: v } = me, { SourceMapConsumer: l, SourceMapGenerator: d } = me, { fileURLToPath: h, pathToFileURL: a } = me, f = tu(), p = Lr(), i = me, r = Symbol("fromOffsetCache"), c = !!(l && d), e = !!(v && E);
  class t {
    get from() {
      return this.file || this.id;
    }
    constructor(b, y = {}) {
      if (b === null || typeof b > "u" || typeof b == "object" && !b.toString)
        throw new Error(`PostCSS received ${b} instead of CSS string`);
      if (this.css = b.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, y.document && (this.document = y.document.toString()), y.from && (!e || /^\w+:\/\//.test(y.from) || E(y.from) ? this.file = y.from : this.file = v(y.from)), e && c) {
        let n = new p(this.css, y);
        if (n.text) {
          this.map = n;
          let m = n.consumer().file;
          !this.file && m && (this.file = this.mapResolve(m));
        }
      }
      this.file || (this.id = "<input css " + u(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(b, y, n, m = {}) {
      let g, x, s;
      if (y && typeof y == "object") {
        let S = y, A = n;
        if (typeof S.offset == "number") {
          let P = this.fromOffset(S.offset);
          y = P.line, n = P.col;
        } else
          y = S.line, n = S.column;
        if (typeof A.offset == "number") {
          let P = this.fromOffset(A.offset);
          x = P.line, g = P.col;
        } else
          x = A.line, g = A.column;
      } else if (!n) {
        let S = this.fromOffset(y);
        y = S.line, n = S.col;
      }
      let w = this.origin(y, n, x, g);
      return w ? s = new f(
        b,
        w.endLine === void 0 ? w.line : { column: w.column, line: w.line },
        w.endLine === void 0 ? w.column : { column: w.endColumn, line: w.endLine },
        w.source,
        w.file,
        m.plugin
      ) : s = new f(
        b,
        x === void 0 ? y : { column: n, line: y },
        x === void 0 ? n : { column: g, line: x },
        this.css,
        this.file,
        m.plugin
      ), s.input = { column: n, endColumn: g, endLine: x, line: y, source: this.css }, this.file && (a && (s.input.url = a(this.file).toString()), s.input.file = this.file), s;
    }
    fromOffset(b) {
      let y, n;
      if (this[r])
        n = this[r];
      else {
        let g = this.css.split(`
`);
        n = new Array(g.length);
        let x = 0;
        for (let s = 0, w = g.length; s < w; s++)
          n[s] = x, x += g[s].length + 1;
        this[r] = n;
      }
      y = n[n.length - 1];
      let m = 0;
      if (b >= y)
        m = n.length - 1;
      else {
        let g = n.length - 2, x;
        for (; m < g; )
          if (x = m + (g - m >> 1), b < n[x])
            g = x - 1;
          else if (b >= n[x + 1])
            m = x + 1;
          else {
            m = x;
            break;
          }
      }
      return {
        col: b - n[m] + 1,
        line: m + 1
      };
    }
    mapResolve(b) {
      return /^\w+:\/\//.test(b) ? b : v(this.map.consumer().sourceRoot || this.map.root || ".", b);
    }
    origin(b, y, n, m) {
      if (!this.map) return !1;
      let g = this.map.consumer(), x = g.originalPositionFor({ column: y, line: b });
      if (!x.source) return !1;
      let s;
      typeof n == "number" && (s = g.originalPositionFor({ column: m, line: n }));
      let w;
      E(x.source) ? w = a(x.source) : w = new URL(
        x.source,
        this.map.consumer().sourceRoot || a(this.map.mapFile)
      );
      let S = {
        column: x.column,
        endColumn: s && s.column,
        endLine: s && s.line,
        line: x.line,
        url: w.toString()
      };
      if (w.protocol === "file:")
        if (h)
          S.file = h(w);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let A = g.sourceContentFor(x.source);
      return A && (S.source = A), S;
    }
    toJSON() {
      let b = {};
      for (let y of ["hasBOM", "css", "file", "id"])
        this[y] != null && (b[y] = this[y]);
      return this.map && (b.map = { ...this.map }, b.map.consumerCache && (b.map.consumerCache = void 0)), b;
    }
  }
  return kt = t, t.default = t, i && i.registerInput && i.registerInput(t), kt;
}
var jt, dr;
function $e() {
  if (dr) return jt;
  dr = 1;
  let u = je(), E, v;
  class l extends u {
    constructor(h) {
      super(h), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(h, a, f) {
      let p = super.normalize(h);
      if (a) {
        if (f === "prepend")
          this.nodes.length > 1 ? a.raws.before = this.nodes[1].raws.before : delete a.raws.before;
        else if (this.first !== a)
          for (let i of p)
            i.raws.before = a.raws.before;
      }
      return p;
    }
    removeChild(h, a) {
      let f = this.index(h);
      return !a && f === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[f].raws.before), super.removeChild(h);
    }
    toResult(h = {}) {
      return new E(new v(), this, h).stringify();
    }
  }
  return l.registerLazyResult = (d) => {
    E = d;
  }, l.registerProcessor = (d) => {
    v = d;
  }, jt = l, l.default = l, u.registerRoot(l), jt;
}
var Bt, hr;
function Mr() {
  if (hr) return Bt;
  hr = 1;
  let u = {
    comma(E) {
      return u.split(E, [","], !0);
    },
    space(E) {
      let v = [" ", `
`, "	"];
      return u.split(E, v);
    },
    split(E, v, l) {
      let d = [], h = "", a = !1, f = 0, p = !1, i = "", r = !1;
      for (let c of E)
        r ? r = !1 : c === "\\" ? r = !0 : p ? c === i && (p = !1) : c === '"' || c === "'" ? (p = !0, i = c) : c === "(" ? f += 1 : c === ")" ? f > 0 && (f -= 1) : f === 0 && v.includes(c) && (a = !0), a ? (h !== "" && d.push(h.trim()), h = "", a = !1) : h += c;
      return (l || h !== "") && d.push(h.trim()), d;
    }
  };
  return Bt = u, u.default = u, Bt;
}
var Ut, pr;
function nu() {
  if (pr) return Ut;
  pr = 1;
  let u = je(), E = Mr();
  class v extends u {
    get selectors() {
      return E.comma(this.selector);
    }
    set selectors(d) {
      let h = this.selector ? this.selector.match(/,\s*/) : null, a = h ? h[0] : "," + this.raw("between", "beforeOpen");
      this.selector = d.join(a);
    }
    constructor(d) {
      super(d), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return Ut = v, v.default = v, u.registerRule(v), Ut;
}
var Ht, br;
function Oi() {
  if (br) return Ht;
  br = 1;
  let u = ru(), E = st(), v = ot(), l = ct(), d = Lr(), h = $e(), a = nu();
  function f(p, i) {
    if (Array.isArray(p)) return p.map((e) => f(e));
    let { inputs: r, ...c } = p;
    if (r) {
      i = [];
      for (let e of r) {
        let t = { ...e, __proto__: l.prototype };
        t.map && (t.map = {
          ...t.map,
          __proto__: d.prototype
        }), i.push(t);
      }
    }
    if (c.nodes && (c.nodes = p.nodes.map((e) => f(e, i))), c.source) {
      let { inputId: e, ...t } = c.source;
      c.source = t, e != null && (c.source.input = i[e]);
    }
    if (c.type === "root")
      return new h(c);
    if (c.type === "decl")
      return new v(c);
    if (c.type === "rule")
      return new a(c);
    if (c.type === "comment")
      return new E(c);
    if (c.type === "atrule")
      return new u(c);
    throw new Error("Unknown node type: " + p.type);
  }
  return Ht = f, f.default = f, Ht;
}
var Ft, mr;
function kr() {
  if (mr) return Ft;
  mr = 1;
  let { dirname: u, relative: E, resolve: v, sep: l } = me, { SourceMapConsumer: d, SourceMapGenerator: h } = me, { pathToFileURL: a } = me, f = ct(), p = !!(d && h), i = !!(u && v && E && l);
  class r {
    constructor(e, t, o, b) {
      this.stringify = e, this.mapOpts = o.map || {}, this.root = t, this.opts = o, this.css = b, this.originalCSS = b, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let e;
      this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
      let t = `
`;
      this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
    }
    applyPrevMaps() {
      for (let e of this.previous()) {
        let t = this.toUrl(this.path(e.file)), o = e.root || u(e.file), b;
        this.mapOpts.sourcesContent === !1 ? (b = new d(e.text), b.sourcesContent && (b.sourcesContent = null)) : b = e.consumer(), this.map.applySourceMap(b, t, this.toUrl(this.path(o)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1)
        if (this.root) {
          let e;
          for (let t = this.root.nodes.length - 1; t >= 0; t--)
            e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
        } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
    }
    generate() {
      if (this.clearAnnotation(), i && p && this.isMap())
        return this.generateMap();
      {
        let e = "";
        return this.stringify(this.root, (t) => {
          e += t;
        }), [e];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let e = this.previous()[0].consumer();
        e.file = this.outputFile(), this.map = h.fromSourceMap(e, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new h({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new h({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let e = 1, t = 1, o = "<no source>", b = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, y, n;
      this.stringify(this.root, (m, g, x) => {
        if (this.css += m, g && x !== "end" && (b.generated.line = e, b.generated.column = t - 1, g.source && g.source.start ? (b.source = this.sourcePath(g), b.original.line = g.source.start.line, b.original.column = g.source.start.column - 1, this.map.addMapping(b)) : (b.source = o, b.original.line = 1, b.original.column = 0, this.map.addMapping(b))), n = m.match(/\n/g), n ? (e += n.length, y = m.lastIndexOf(`
`), t = m.length - y) : t += m.length, g && x !== "start") {
          let s = g.parent || { raws: {} };
          (!(g.type === "decl" || g.type === "atrule" && !g.nodes) || g !== s.last || s.raws.semicolon) && (g.source && g.source.end ? (b.source = this.sourcePath(g), b.original.line = g.source.end.line, b.original.column = g.source.end.column - 1, b.generated.line = e, b.generated.column = t - 2, this.map.addMapping(b)) : (b.source = o, b.original.line = 1, b.original.column = 0, b.generated.line = e, b.generated.column = t - 1, this.map.addMapping(b)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let e = this.mapOpts.annotation;
      return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(e) {
      if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
      let t = this.memoizedPaths.get(e);
      if (t) return t;
      let o = this.opts.to ? u(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (o = u(v(o, this.mapOpts.annotation)));
      let b = E(o, e);
      return this.memoizedPaths.set(e, b), b;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((e) => {
            if (e.source && e.source.input.map) {
              let t = e.source.input.map;
              this.previousMaps.includes(t) || this.previousMaps.push(t);
            }
          });
        else {
          let e = new f(this.originalCSS, this.opts);
          e.map && this.previousMaps.push(e.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let e = {};
      if (this.root)
        this.root.walk((t) => {
          if (t.source) {
            let o = t.source.input.from;
            if (o && !e[o]) {
              e[o] = !0;
              let b = this.usesFileUrls ? this.toFileUrl(o) : this.toUrl(this.path(o));
              this.map.setSourceContent(b, t.source.input.css);
            }
          }
        });
      else if (this.css) {
        let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(t, this.css);
      }
    }
    sourcePath(e) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
    }
    toBase64(e) {
      return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
    }
    toFileUrl(e) {
      let t = this.memoizedFileURLs.get(e);
      if (t) return t;
      if (a) {
        let o = a(e).toString();
        return this.memoizedFileURLs.set(e, o), o;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(e) {
      let t = this.memoizedURLs.get(e);
      if (t) return t;
      l === "\\" && (e = e.replace(/\\/g, "/"));
      let o = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(e, o), o;
    }
  }
  return Ft = r, Ft;
}
var Vt, gr;
function Ni() {
  if (gr) return Vt;
  gr = 1;
  const u = 39, E = 34, v = 92, l = 47, d = 10, h = 32, a = 12, f = 9, p = 13, i = 91, r = 93, c = 40, e = 41, t = 123, o = 125, b = 59, y = 42, n = 58, m = 64, g = /[\t\n\f\r "#'()/;[\\\]{}]/g, x = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, s = /.[\r\n"'(/\\]/, w = /[\da-f]/i;
  return Vt = function(A, P = {}) {
    let R = A.css.valueOf(), _ = P.ignoreErrors, O, q, M, N, V, z, J, ee, te, oe, Ne = R.length, B = 0, ce = [], ve = [];
    function Ce() {
      return B;
    }
    function xe(C) {
      throw A.error("Unclosed " + C, B);
    }
    function Re() {
      return ve.length === 0 && B >= Ne;
    }
    function De(C) {
      if (ve.length) return ve.pop();
      if (B >= Ne) return;
      let L = C ? C.ignoreUnclosed : !1;
      switch (O = R.charCodeAt(B), O) {
        case d:
        case h:
        case f:
        case p:
        case a: {
          N = B;
          do
            N += 1, O = R.charCodeAt(N);
          while (O === h || O === d || O === f || O === p || O === a);
          z = ["space", R.slice(B, N)], B = N - 1;
          break;
        }
        case i:
        case r:
        case t:
        case o:
        case n:
        case b:
        case e: {
          let I = String.fromCharCode(O);
          z = [I, I, B];
          break;
        }
        case c: {
          if (oe = ce.length ? ce.pop()[1] : "", te = R.charCodeAt(B + 1), oe === "url" && te !== u && te !== E && te !== h && te !== d && te !== f && te !== a && te !== p) {
            N = B;
            do {
              if (J = !1, N = R.indexOf(")", N + 1), N === -1)
                if (_ || L) {
                  N = B;
                  break;
                } else
                  xe("bracket");
              for (ee = N; R.charCodeAt(ee - 1) === v; )
                ee -= 1, J = !J;
            } while (J);
            z = ["brackets", R.slice(B, N + 1), B, N], B = N;
          } else
            N = R.indexOf(")", B + 1), q = R.slice(B, N + 1), N === -1 || s.test(q) ? z = ["(", "(", B] : (z = ["brackets", q, B, N], B = N);
          break;
        }
        case u:
        case E: {
          V = O === u ? "'" : '"', N = B;
          do {
            if (J = !1, N = R.indexOf(V, N + 1), N === -1)
              if (_ || L) {
                N = B + 1;
                break;
              } else
                xe("string");
            for (ee = N; R.charCodeAt(ee - 1) === v; )
              ee -= 1, J = !J;
          } while (J);
          z = ["string", R.slice(B, N + 1), B, N], B = N;
          break;
        }
        case m: {
          g.lastIndex = B + 1, g.test(R), g.lastIndex === 0 ? N = R.length - 1 : N = g.lastIndex - 2, z = ["at-word", R.slice(B, N + 1), B, N], B = N;
          break;
        }
        case v: {
          for (N = B, M = !0; R.charCodeAt(N + 1) === v; )
            N += 1, M = !M;
          if (O = R.charCodeAt(N + 1), M && O !== l && O !== h && O !== d && O !== f && O !== p && O !== a && (N += 1, w.test(R.charAt(N)))) {
            for (; w.test(R.charAt(N + 1)); )
              N += 1;
            R.charCodeAt(N + 1) === h && (N += 1);
          }
          z = ["word", R.slice(B, N + 1), B, N], B = N;
          break;
        }
        default: {
          O === l && R.charCodeAt(B + 1) === y ? (N = R.indexOf("*/", B + 2) + 1, N === 0 && (_ || L ? N = R.length : xe("comment")), z = ["comment", R.slice(B, N + 1), B, N], B = N) : (x.lastIndex = B + 1, x.test(R), x.lastIndex === 0 ? N = R.length - 1 : N = x.lastIndex - 2, z = ["word", R.slice(B, N + 1), B, N], ce.push(z), B = N);
          break;
        }
      }
      return B++, z;
    }
    function we(C) {
      ve.push(C);
    }
    return {
      back: we,
      endOfFile: Re,
      nextToken: De,
      position: Ce
    };
  }, Vt;
}
var zt, yr;
function Ci() {
  if (yr) return zt;
  yr = 1;
  let u = ru(), E = st(), v = ot(), l = $e(), d = nu(), h = Ni();
  const a = {
    empty: !0,
    space: !0
  };
  function f(i) {
    for (let r = i.length - 1; r >= 0; r--) {
      let c = i[r], e = c[3] || c[2];
      if (e) return e;
    }
  }
  class p {
    constructor(r) {
      this.input = r, this.root = new l(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: r, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(r) {
      let c = new u();
      c.name = r[1].slice(1), c.name === "" && this.unnamedAtrule(c, r), this.init(c, r[2]);
      let e, t, o, b = !1, y = !1, n = [], m = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (r = this.tokenizer.nextToken(), e = r[0], e === "(" || e === "[" ? m.push(e === "(" ? ")" : "]") : e === "{" && m.length > 0 ? m.push("}") : e === m[m.length - 1] && m.pop(), m.length === 0)
          if (e === ";") {
            c.source.end = this.getPosition(r[2]), c.source.end.offset++, this.semicolon = !0;
            break;
          } else if (e === "{") {
            y = !0;
            break;
          } else if (e === "}") {
            if (n.length > 0) {
              for (o = n.length - 1, t = n[o]; t && t[0] === "space"; )
                t = n[--o];
              t && (c.source.end = this.getPosition(t[3] || t[2]), c.source.end.offset++);
            }
            this.end(r);
            break;
          } else
            n.push(r);
        else
          n.push(r);
        if (this.tokenizer.endOfFile()) {
          b = !0;
          break;
        }
      }
      c.raws.between = this.spacesAndCommentsFromEnd(n), n.length ? (c.raws.afterName = this.spacesAndCommentsFromStart(n), this.raw(c, "params", n), b && (r = n[n.length - 1], c.source.end = this.getPosition(r[3] || r[2]), c.source.end.offset++, this.spaces = c.raws.between, c.raws.between = "")) : (c.raws.afterName = "", c.params = ""), y && (c.nodes = [], this.current = c);
    }
    checkMissedSemicolon(r) {
      let c = this.colon(r);
      if (c === !1) return;
      let e = 0, t;
      for (let o = c - 1; o >= 0 && (t = r[o], !(t[0] !== "space" && (e += 1, e === 2))); o--)
        ;
      throw this.input.error(
        "Missed semicolon",
        t[0] === "word" ? t[3] + 1 : t[2]
      );
    }
    colon(r) {
      let c = 0, e, t, o;
      for (let [b, y] of r.entries()) {
        if (t = y, o = t[0], o === "(" && (c += 1), o === ")" && (c -= 1), c === 0 && o === ":")
          if (!e)
            this.doubleColon(t);
          else {
            if (e[0] === "word" && e[1] === "progid")
              continue;
            return b;
          }
        e = t;
      }
      return !1;
    }
    comment(r) {
      let c = new E();
      this.init(c, r[2]), c.source.end = this.getPosition(r[3] || r[2]), c.source.end.offset++;
      let e = r[1].slice(2, -2);
      if (/^\s*$/.test(e))
        c.text = "", c.raws.left = e, c.raws.right = "";
      else {
        let t = e.match(/^(\s*)([^]*\S)(\s*)$/);
        c.text = t[2], c.raws.left = t[1], c.raws.right = t[3];
      }
    }
    createTokenizer() {
      this.tokenizer = h(this.input);
    }
    decl(r, c) {
      let e = new v();
      this.init(e, r[0][2]);
      let t = r[r.length - 1];
      for (t[0] === ";" && (this.semicolon = !0, r.pop()), e.source.end = this.getPosition(
        t[3] || t[2] || f(r)
      ), e.source.end.offset++; r[0][0] !== "word"; )
        r.length === 1 && this.unknownWord(r), e.raws.before += r.shift()[1];
      for (e.source.start = this.getPosition(r[0][2]), e.prop = ""; r.length; ) {
        let m = r[0][0];
        if (m === ":" || m === "space" || m === "comment")
          break;
        e.prop += r.shift()[1];
      }
      e.raws.between = "";
      let o;
      for (; r.length; )
        if (o = r.shift(), o[0] === ":") {
          e.raws.between += o[1];
          break;
        } else
          o[0] === "word" && /\w/.test(o[1]) && this.unknownWord([o]), e.raws.between += o[1];
      (e.prop[0] === "_" || e.prop[0] === "*") && (e.raws.before += e.prop[0], e.prop = e.prop.slice(1));
      let b = [], y;
      for (; r.length && (y = r[0][0], !(y !== "space" && y !== "comment")); )
        b.push(r.shift());
      this.precheckMissedSemicolon(r);
      for (let m = r.length - 1; m >= 0; m--) {
        if (o = r[m], o[1].toLowerCase() === "!important") {
          e.important = !0;
          let g = this.stringFrom(r, m);
          g = this.spacesFromEnd(r) + g, g !== " !important" && (e.raws.important = g);
          break;
        } else if (o[1].toLowerCase() === "important") {
          let g = r.slice(0), x = "";
          for (let s = m; s > 0; s--) {
            let w = g[s][0];
            if (x.trim().startsWith("!") && w !== "space")
              break;
            x = g.pop()[1] + x;
          }
          x.trim().startsWith("!") && (e.important = !0, e.raws.important = x, r = g);
        }
        if (o[0] !== "space" && o[0] !== "comment")
          break;
      }
      r.some((m) => m[0] !== "space" && m[0] !== "comment") && (e.raws.between += b.map((m) => m[1]).join(""), b = []), this.raw(e, "value", b.concat(r), c), e.value.includes(":") && !c && this.checkMissedSemicolon(r);
    }
    doubleColon(r) {
      throw this.input.error(
        "Double colon",
        { offset: r[2] },
        { offset: r[2] + r[1].length }
      );
    }
    emptyRule(r) {
      let c = new d();
      this.init(c, r[2]), c.selector = "", c.raws.between = "", this.current = c;
    }
    end(r) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(r[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(r);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(r) {
      if (this.spaces += r[1], this.current.nodes) {
        let c = this.current.nodes[this.current.nodes.length - 1];
        c && c.type === "rule" && !c.raws.ownSemicolon && (c.raws.ownSemicolon = this.spaces, this.spaces = "", c.source.end = this.getPosition(r[2]), c.source.end.offset += c.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(r) {
      let c = this.input.fromOffset(r);
      return {
        column: c.col,
        line: c.line,
        offset: r
      };
    }
    init(r, c) {
      this.current.push(r), r.source = {
        input: this.input,
        start: this.getPosition(c)
      }, r.raws.before = this.spaces, this.spaces = "", r.type !== "comment" && (this.semicolon = !1);
    }
    other(r) {
      let c = !1, e = null, t = !1, o = null, b = [], y = r[1].startsWith("--"), n = [], m = r;
      for (; m; ) {
        if (e = m[0], n.push(m), e === "(" || e === "[")
          o || (o = m), b.push(e === "(" ? ")" : "]");
        else if (y && t && e === "{")
          o || (o = m), b.push("}");
        else if (b.length === 0)
          if (e === ";")
            if (t) {
              this.decl(n, y);
              return;
            } else
              break;
          else if (e === "{") {
            this.rule(n);
            return;
          } else if (e === "}") {
            this.tokenizer.back(n.pop()), c = !0;
            break;
          } else e === ":" && (t = !0);
        else e === b[b.length - 1] && (b.pop(), b.length === 0 && (o = null));
        m = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (c = !0), b.length > 0 && this.unclosedBracket(o), c && t) {
        if (!y)
          for (; n.length && (m = n[n.length - 1][0], !(m !== "space" && m !== "comment")); )
            this.tokenizer.back(n.pop());
        this.decl(n, y);
      } else
        this.unknownWord(n);
    }
    parse() {
      let r;
      for (; !this.tokenizer.endOfFile(); )
        switch (r = this.tokenizer.nextToken(), r[0]) {
          case "space":
            this.spaces += r[1];
            break;
          case ";":
            this.freeSemicolon(r);
            break;
          case "}":
            this.end(r);
            break;
          case "comment":
            this.comment(r);
            break;
          case "at-word":
            this.atrule(r);
            break;
          case "{":
            this.emptyRule(r);
            break;
          default:
            this.other(r);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(r, c, e, t) {
      let o, b, y = e.length, n = "", m = !0, g, x;
      for (let s = 0; s < y; s += 1)
        o = e[s], b = o[0], b === "space" && s === y - 1 && !t ? m = !1 : b === "comment" ? (x = e[s - 1] ? e[s - 1][0] : "empty", g = e[s + 1] ? e[s + 1][0] : "empty", !a[x] && !a[g] ? n.slice(-1) === "," ? m = !1 : n += o[1] : m = !1) : n += o[1];
      if (!m) {
        let s = e.reduce((w, S) => w + S[1], "");
        r.raws[c] = { raw: s, value: n };
      }
      r[c] = n;
    }
    rule(r) {
      r.pop();
      let c = new d();
      this.init(c, r[0][2]), c.raws.between = this.spacesAndCommentsFromEnd(r), this.raw(c, "selector", r), this.current = c;
    }
    spacesAndCommentsFromEnd(r) {
      let c, e = "";
      for (; r.length && (c = r[r.length - 1][0], !(c !== "space" && c !== "comment")); )
        e = r.pop()[1] + e;
      return e;
    }
    // Errors
    spacesAndCommentsFromStart(r) {
      let c, e = "";
      for (; r.length && (c = r[0][0], !(c !== "space" && c !== "comment")); )
        e += r.shift()[1];
      return e;
    }
    spacesFromEnd(r) {
      let c, e = "";
      for (; r.length && (c = r[r.length - 1][0], c === "space"); )
        e = r.pop()[1] + e;
      return e;
    }
    stringFrom(r, c) {
      let e = "";
      for (let t = c; t < r.length; t++)
        e += r[t][1];
      return r.splice(c, r.length - c), e;
    }
    unclosedBlock() {
      let r = this.current.source.start;
      throw this.input.error("Unclosed block", r.line, r.column);
    }
    unclosedBracket(r) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unexpectedClose(r) {
      throw this.input.error(
        "Unexpected }",
        { offset: r[2] },
        { offset: r[2] + 1 }
      );
    }
    unknownWord(r) {
      throw this.input.error(
        "Unknown word " + r[0][1],
        { offset: r[0][2] },
        { offset: r[0][2] + r[0][1].length }
      );
    }
    unnamedAtrule(r, c) {
      throw this.input.error(
        "At-rule without name",
        { offset: c[2] },
        { offset: c[2] + c[1].length }
      );
    }
  }
  return zt = p, zt;
}
var $t, vr;
function au() {
  if (vr) return $t;
  vr = 1;
  let u = je(), E = ct(), v = Ci();
  function l(d, h) {
    let a = new E(d, h), f = new v(a);
    try {
      f.parse();
    } catch (p) {
      throw process.env.NODE_ENV !== "production" && p.name === "CssSyntaxError" && h && h.from && (/\.scss$/i.test(h.from) ? p.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(h.from) ? p.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(h.from) && (p.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), p;
    }
    return f.root;
  }
  return $t = l, l.default = l, u.registerParse(l), $t;
}
var Gt, xr;
function jr() {
  if (xr) return Gt;
  xr = 1;
  class u {
    constructor(v, l = {}) {
      if (this.type = "warning", this.text = v, l.node && l.node.source) {
        let d = l.node.rangeBy(l);
        this.line = d.start.line, this.column = d.start.column, this.endLine = d.end.line, this.endColumn = d.end.column;
      }
      for (let d in l) this[d] = l[d];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return Gt = u, u.default = u, Gt;
}
var Wt, wr;
function su() {
  if (wr) return Wt;
  wr = 1;
  let u = jr();
  class E {
    get content() {
      return this.css;
    }
    constructor(l, d, h) {
      this.processor = l, this.messages = [], this.root = d, this.opts = h, this.css = void 0, this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(l, d = {}) {
      d.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (d.plugin = this.lastPlugin.postcssPlugin);
      let h = new u(l, d);
      return this.messages.push(h), h;
    }
    warnings() {
      return this.messages.filter((l) => l.type === "warning");
    }
  }
  return Wt = E, E.default = E, Wt;
}
var Yt, Er;
function Br() {
  if (Er) return Yt;
  Er = 1;
  let u = {};
  return Yt = function(v) {
    u[v] || (u[v] = !0, typeof console < "u" && console.warn && console.warn(v));
  }, Yt;
}
var Jt, Sr;
function Ur() {
  if (Sr) return Jt;
  Sr = 1;
  let u = je(), E = iu(), v = kr(), l = au(), d = su(), h = $e(), a = nt(), { isClean: f, my: p } = uu(), i = Br();
  const r = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, c = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, e = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, t = 0;
  function o(x) {
    return typeof x == "object" && typeof x.then == "function";
  }
  function b(x) {
    let s = !1, w = r[x.type];
    return x.type === "decl" ? s = x.prop.toLowerCase() : x.type === "atrule" && (s = x.name.toLowerCase()), s && x.append ? [
      w,
      w + "-" + s,
      t,
      w + "Exit",
      w + "Exit-" + s
    ] : s ? [w, w + "-" + s, w + "Exit", w + "Exit-" + s] : x.append ? [w, t, w + "Exit"] : [w, w + "Exit"];
  }
  function y(x) {
    let s;
    return x.type === "document" ? s = ["Document", t, "DocumentExit"] : x.type === "root" ? s = ["Root", t, "RootExit"] : s = b(x), {
      eventIndex: 0,
      events: s,
      iterator: 0,
      node: x,
      visitorIndex: 0,
      visitors: []
    };
  }
  function n(x) {
    return x[f] = !1, x.nodes && x.nodes.forEach((s) => n(s)), x;
  }
  let m = {};
  class g {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(s, w, S) {
      this.stringified = !1, this.processed = !1;
      let A;
      if (typeof w == "object" && w !== null && (w.type === "root" || w.type === "document"))
        A = n(w);
      else if (w instanceof g || w instanceof d)
        A = n(w.root), w.map && (typeof S.map > "u" && (S.map = {}), S.map.inline || (S.map.inline = !1), S.map.prev = w.map);
      else {
        let P = l;
        S.syntax && (P = S.syntax.parse), S.parser && (P = S.parser), P.parse && (P = P.parse);
        try {
          A = P(w, S);
        } catch (R) {
          this.processed = !0, this.error = R;
        }
        A && !A[p] && u.rebuild(A);
      }
      this.result = new d(s, A, S), this.helpers = { ...m, postcss: m, result: this.result }, this.plugins = this.processor.plugins.map((P) => typeof P == "object" && P.prepare ? { ...P, ...P.prepare(this.result) } : P);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(s) {
      return this.async().catch(s);
    }
    finally(s) {
      return this.async().then(s, s);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(s, w) {
      let S = this.result.lastPlugin;
      try {
        if (w && w.addToError(s), this.error = s, s.name === "CssSyntaxError" && !s.plugin)
          s.plugin = S.postcssPlugin, s.setMessage();
        else if (S.postcssVersion && process.env.NODE_ENV !== "production") {
          let A = S.postcssPlugin, P = S.postcssVersion, R = this.result.processor.version, _ = P.split("."), O = R.split(".");
          (_[0] !== O[0] || parseInt(_[1]) > parseInt(O[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + R + ", but " + A + " uses " + P + ". Perhaps this is the source of the error below."
          );
        }
      } catch (A) {
        console && console.error && console.error(A);
      }
      return s;
    }
    prepareVisitors() {
      this.listeners = {};
      let s = (w, S, A) => {
        this.listeners[S] || (this.listeners[S] = []), this.listeners[S].push([w, A]);
      };
      for (let w of this.plugins)
        if (typeof w == "object")
          for (let S in w) {
            if (!c[S] && /^[A-Z]/.test(S))
              throw new Error(
                `Unknown event ${S} in ${w.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!e[S])
              if (typeof w[S] == "object")
                for (let A in w[S])
                  A === "*" ? s(w, S, w[S][A]) : s(
                    w,
                    S + "-" + A.toLowerCase(),
                    w[S][A]
                  );
              else typeof w[S] == "function" && s(w, S, w[S]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let s = 0; s < this.plugins.length; s++) {
        let w = this.plugins[s], S = this.runOnRoot(w);
        if (o(S))
          try {
            await S;
          } catch (A) {
            throw this.handleError(A);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let s = this.result.root;
        for (; !s[f]; ) {
          s[f] = !0;
          let w = [y(s)];
          for (; w.length > 0; ) {
            let S = this.visitTick(w);
            if (o(S))
              try {
                await S;
              } catch (A) {
                let P = w[w.length - 1].node;
                throw this.handleError(A, P);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [w, S] of this.listeners.OnceExit) {
            this.result.lastPlugin = w;
            try {
              if (s.type === "document") {
                let A = s.nodes.map(
                  (P) => S(P, this.helpers)
                );
                await Promise.all(A);
              } else
                await S(s, this.helpers);
            } catch (A) {
              throw this.handleError(A);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(s) {
      this.result.lastPlugin = s;
      try {
        if (typeof s == "object" && s.Once) {
          if (this.result.root.type === "document") {
            let w = this.result.root.nodes.map(
              (S) => s.Once(S, this.helpers)
            );
            return o(w[0]) ? Promise.all(w) : w;
          }
          return s.Once(this.result.root, this.helpers);
        } else if (typeof s == "function")
          return s(this.result.root, this.result);
      } catch (w) {
        throw this.handleError(w);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let s = this.result.opts, w = a;
      s.syntax && (w = s.syntax.stringify), s.stringifier && (w = s.stringifier), w.stringify && (w = w.stringify);
      let A = new v(w, this.result.root, this.result.opts).generate();
      return this.result.css = A[0], this.result.map = A[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let s of this.plugins) {
        let w = this.runOnRoot(s);
        if (o(w))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let s = this.result.root;
        for (; !s[f]; )
          s[f] = !0, this.walkSync(s);
        if (this.listeners.OnceExit)
          if (s.type === "document")
            for (let w of s.nodes)
              this.visitSync(this.listeners.OnceExit, w);
          else
            this.visitSync(this.listeners.OnceExit, s);
      }
      return this.result;
    }
    then(s, w) {
      return process.env.NODE_ENV !== "production" && ("from" in this.opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(s, w);
    }
    toString() {
      return this.css;
    }
    visitSync(s, w) {
      for (let [S, A] of s) {
        this.result.lastPlugin = S;
        let P;
        try {
          P = A(w, this.helpers);
        } catch (R) {
          throw this.handleError(R, w.proxyOf);
        }
        if (w.type !== "root" && w.type !== "document" && !w.parent)
          return !0;
        if (o(P))
          throw this.getAsyncError();
      }
    }
    visitTick(s) {
      let w = s[s.length - 1], { node: S, visitors: A } = w;
      if (S.type !== "root" && S.type !== "document" && !S.parent) {
        s.pop();
        return;
      }
      if (A.length > 0 && w.visitorIndex < A.length) {
        let [R, _] = A[w.visitorIndex];
        w.visitorIndex += 1, w.visitorIndex === A.length && (w.visitors = [], w.visitorIndex = 0), this.result.lastPlugin = R;
        try {
          return _(S.toProxy(), this.helpers);
        } catch (O) {
          throw this.handleError(O, S);
        }
      }
      if (w.iterator !== 0) {
        let R = w.iterator, _;
        for (; _ = S.nodes[S.indexes[R]]; )
          if (S.indexes[R] += 1, !_[f]) {
            _[f] = !0, s.push(y(_));
            return;
          }
        w.iterator = 0, delete S.indexes[R];
      }
      let P = w.events;
      for (; w.eventIndex < P.length; ) {
        let R = P[w.eventIndex];
        if (w.eventIndex += 1, R === t) {
          S.nodes && S.nodes.length && (S[f] = !0, w.iterator = S.getIterator());
          return;
        } else if (this.listeners[R]) {
          w.visitors = this.listeners[R];
          return;
        }
      }
      s.pop();
    }
    walkSync(s) {
      s[f] = !0;
      let w = b(s);
      for (let S of w)
        if (S === t)
          s.nodes && s.each((A) => {
            A[f] || this.walkSync(A);
          });
        else {
          let A = this.listeners[S];
          if (A && this.visitSync(A, s.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return g.registerPostcss = (x) => {
    m = x;
  }, Jt = g, g.default = g, h.registerLazyResult(g), E.registerLazyResult(g), Jt;
}
var Xt, Tr;
function Ri() {
  if (Tr) return Xt;
  Tr = 1;
  let u = kr(), E = au();
  const v = su();
  let l = nt(), d = Br();
  class h {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let f, p = E;
      try {
        f = p(this._css, this._opts);
      } catch (i) {
        this.error = i;
      }
      if (this.error)
        throw this.error;
      return this._root = f, f;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(f, p, i) {
      p = p.toString(), this.stringified = !1, this._processor = f, this._css = p, this._opts = i, this._map = void 0;
      let r, c = l;
      this.result = new v(this._processor, r, this._opts), this.result.css = p;
      let e = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return e.root;
        }
      });
      let t = new u(c, r, this._opts, p);
      if (t.isMap()) {
        let [o, b] = t.generate();
        o && (this.result.css = o), b && (this.result.map = b);
      } else
        t.clearAnnotation(), this.result.css = t.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(f) {
      return this.async().catch(f);
    }
    finally(f) {
      return this.async().then(f, f);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(f, p) {
      return process.env.NODE_ENV !== "production" && ("from" in this._opts || d(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(f, p);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return Xt = h, h.default = h, Xt;
}
var Qt, Ar;
function Pi() {
  if (Ar) return Qt;
  Ar = 1;
  let u = iu(), E = Ur(), v = Ri(), l = $e();
  class d {
    constructor(a = []) {
      this.version = "8.5.3", this.plugins = this.normalize(a);
    }
    normalize(a) {
      let f = [];
      for (let p of a)
        if (p.postcss === !0 ? p = p() : p.postcss && (p = p.postcss), typeof p == "object" && Array.isArray(p.plugins))
          f = f.concat(p.plugins);
        else if (typeof p == "object" && p.postcssPlugin)
          f.push(p);
        else if (typeof p == "function")
          f.push(p);
        else if (typeof p == "object" && (p.parse || p.stringify)) {
          if (process.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(p + " is not a PostCSS plugin");
      return f;
    }
    process(a, f = {}) {
      return !this.plugins.length && !f.parser && !f.stringifier && !f.syntax ? new v(this, a, f) : new E(this, a, f);
    }
    use(a) {
      return this.plugins = this.plugins.concat(this.normalize([a])), this;
    }
  }
  return Qt = d, d.default = d, l.registerProcessor(d), u.registerProcessor(d), Qt;
}
var Zt, _r;
function Ii() {
  if (_r) return Zt;
  _r = 1;
  let u = ru(), E = st(), v = je(), l = tu(), d = ot(), h = iu(), a = Oi(), f = ct(), p = Ur(), i = Mr(), r = at(), c = au(), e = Pi(), t = su(), o = $e(), b = nu(), y = nt(), n = jr();
  function m(...g) {
    return g.length === 1 && Array.isArray(g[0]) && (g = g[0]), new e(g);
  }
  return m.plugin = function(x, s) {
    let w = !1;
    function S(...P) {
      console && console.warn && !w && (w = !0, console.warn(
        x + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
        x + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let R = s(...P);
      return R.postcssPlugin = x, R.postcssVersion = new e().version, R;
    }
    let A;
    return Object.defineProperty(S, "postcss", {
      get() {
        return A || (A = S()), A;
      }
    }), S.process = function(P, R, _) {
      return m([S(_)]).process(P, R);
    }, S;
  }, m.stringify = y, m.parse = c, m.fromJSON = a, m.list = i, m.comment = (g) => new E(g), m.atRule = (g) => new u(g), m.decl = (g) => new d(g), m.rule = (g) => new b(g), m.root = (g) => new o(g), m.document = (g) => new h(g), m.CssSyntaxError = l, m.Declaration = d, m.Container = v, m.Processor = e, m.Document = h, m.Comment = E, m.Warning = n, m.AtRule = u, m.Result = t, m.Input = f, m.Rule = b, m.Root = o, m.Node = r, p.registerPostcss(m), Zt = m, m.default = m, Zt;
}
var Kt, Or;
function Di() {
  if (Or) return Kt;
  Or = 1;
  const u = /* @__PURE__ */ gi(), E = yi(), { isPlainObject: v } = vi(), l = xi(), d = Ei(), { parse: h } = Ii(), a = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], f = ["script", "style"];
  function p(y, n) {
    y && Object.keys(y).forEach(function(m) {
      n(y[m], m);
    });
  }
  function i(y, n) {
    return {}.hasOwnProperty.call(y, n);
  }
  function r(y, n) {
    const m = [];
    return p(y, function(g) {
      n(g) && m.push(g);
    }), m;
  }
  function c(y) {
    for (const n in y)
      if (i(y, n))
        return !1;
    return !0;
  }
  function e(y) {
    return y.map(function(n) {
      if (!n.url)
        throw new Error("URL missing");
      return n.url + (n.w ? ` ${n.w}w` : "") + (n.h ? ` ${n.h}h` : "") + (n.d ? ` ${n.d}x` : "");
    }).join(", ");
  }
  Kt = o;
  const t = /^[^\0\t\n\f\r /<=>]+$/;
  function o(y, n, m) {
    if (y == null)
      return "";
    typeof y == "number" && (y = y.toString());
    let g = "", x = "";
    function s(C, L) {
      const I = this;
      this.tag = C, this.attribs = L || {}, this.tagPosition = g.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (V.length) {
          const H = V[V.length - 1];
          H.text += I.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        V.length && a.includes(this.tag) && V[V.length - 1].mediaChildren.push(this.tag);
      };
    }
    n = Object.assign({}, o.defaults, n), n.parser = Object.assign({}, b, n.parser);
    const w = function(C) {
      return n.allowedTags === !1 || (n.allowedTags || []).indexOf(C) > -1;
    };
    f.forEach(function(C) {
      w(C) && !n.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${C}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const S = n.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let A, P;
    n.allowedAttributes && (A = {}, P = {}, p(n.allowedAttributes, function(C, L) {
      A[L] = [];
      const I = [];
      C.forEach(function(H) {
        typeof H == "string" && H.indexOf("*") >= 0 ? I.push(E(H).replace(/\\\*/g, ".*")) : A[L].push(H);
      }), I.length && (P[L] = new RegExp("^(" + I.join("|") + ")$"));
    }));
    const R = {}, _ = {}, O = {};
    p(n.allowedClasses, function(C, L) {
      if (A && (i(A, L) || (A[L] = []), A[L].push("class")), R[L] = C, Array.isArray(C)) {
        const I = [];
        R[L] = [], O[L] = [], C.forEach(function(H) {
          typeof H == "string" && H.indexOf("*") >= 0 ? I.push(E(H).replace(/\\\*/g, ".*")) : H instanceof RegExp ? O[L].push(H) : R[L].push(H);
        }), I.length && (_[L] = new RegExp("^(" + I.join("|") + ")$"));
      }
    });
    const q = {};
    let M;
    p(n.transformTags, function(C, L) {
      let I;
      typeof C == "function" ? I = C : typeof C == "string" && (I = o.simpleTransform(C)), L === "*" ? M = I : q[L] = I;
    });
    let N, V, z, J, ee, te, oe = !1;
    B();
    const Ne = new u.Parser({
      onopentag: function(C, L) {
        if (n.onOpenTag && n.onOpenTag(C, L), n.enforceHtmlBoundary && C === "html" && B(), ee) {
          te++;
          return;
        }
        const I = new s(C, L);
        V.push(I);
        let H = !1;
        const ue = !!I.text;
        let ne;
        if (i(q, C) && (ne = q[C](C, L), I.attribs = L = ne.attribs, ne.text !== void 0 && (I.innerText = ne.text), C !== ne.tagName && (I.name = C = ne.tagName, J[N] = ne.tagName)), M && (ne = M(C, L), I.attribs = L = ne.attribs, C !== ne.tagName && (I.name = C = ne.tagName, J[N] = ne.tagName)), (!w(C) || n.disallowedTagsMode === "recursiveEscape" && !c(z) || n.nestingLimit != null && N >= n.nestingLimit) && (H = !0, z[N] = !0, (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && S.indexOf(C) !== -1 && (ee = !0, te = 1)), N++, H) {
          if (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
            if (I.innerText && !ue) {
              const Q = ce(I.innerText);
              n.textFilter ? g += n.textFilter(Q, C) : g += Q, oe = !0;
            }
            return;
          }
          x = g, g = "";
        }
        g += "<" + C, C === "script" && (n.allowedScriptHostnames || n.allowedScriptDomains) && (I.innerText = ""), H && (n.disallowedTagsMode === "escape" || n.disallowedTagsMode === "recursiveEscape") && n.preserveEscapedAttributes ? p(L, function(Q, G) {
          g += " " + G + '="' + ce(Q || "", !0) + '"';
        }) : (!A || i(A, C) || A["*"]) && p(L, function(Q, G) {
          if (!t.test(G)) {
            delete I.attribs[G];
            return;
          }
          if (Q === "" && !n.allowedEmptyAttributes.includes(G) && (n.nonBooleanAttributes.includes(G) || n.nonBooleanAttributes.includes("*"))) {
            delete I.attribs[G];
            return;
          }
          let qe = !1;
          if (!A || i(A, C) && A[C].indexOf(G) !== -1 || A["*"] && A["*"].indexOf(G) !== -1 || i(P, C) && P[C].test(G) || P["*"] && P["*"].test(G))
            qe = !0;
          else if (A && A[C]) {
            for (const X of A[C])
              if (v(X) && X.name && X.name === G) {
                qe = !0;
                let Y = "";
                if (X.multiple === !0) {
                  const ge = Q.split(" ");
                  for (const fe of ge)
                    X.values.indexOf(fe) !== -1 && (Y === "" ? Y = fe : Y += " " + fe);
                } else X.values.indexOf(Q) >= 0 && (Y = Q);
                Q = Y;
              }
          }
          if (qe) {
            if (n.allowedSchemesAppliedToAttributes.indexOf(G) !== -1 && ve(C, Q)) {
              delete I.attribs[G];
              return;
            }
            if (C === "script" && G === "src") {
              let X = !0;
              try {
                const Y = Ce(Q);
                if (n.allowedScriptHostnames || n.allowedScriptDomains) {
                  const ge = (n.allowedScriptHostnames || []).find(function(le) {
                    return le === Y.url.hostname;
                  }), fe = (n.allowedScriptDomains || []).find(function(le) {
                    return Y.url.hostname === le || Y.url.hostname.endsWith(`.${le}`);
                  });
                  X = ge || fe;
                }
              } catch {
                X = !1;
              }
              if (!X) {
                delete I.attribs[G];
                return;
              }
            }
            if (C === "iframe" && G === "src") {
              let X = !0;
              try {
                const Y = Ce(Q);
                if (Y.isRelativeUrl)
                  X = i(n, "allowIframeRelativeUrls") ? n.allowIframeRelativeUrls : !n.allowedIframeHostnames && !n.allowedIframeDomains;
                else if (n.allowedIframeHostnames || n.allowedIframeDomains) {
                  const ge = (n.allowedIframeHostnames || []).find(function(le) {
                    return le === Y.url.hostname;
                  }), fe = (n.allowedIframeDomains || []).find(function(le) {
                    return Y.url.hostname === le || Y.url.hostname.endsWith(`.${le}`);
                  });
                  X = ge || fe;
                }
              } catch {
                X = !1;
              }
              if (!X) {
                delete I.attribs[G];
                return;
              }
            }
            if (G === "srcset")
              try {
                let X = d(Q);
                if (X.forEach(function(Y) {
                  ve("srcset", Y.url) && (Y.evil = !0);
                }), X = r(X, function(Y) {
                  return !Y.evil;
                }), X.length)
                  Q = e(r(X, function(Y) {
                    return !Y.evil;
                  })), I.attribs[G] = Q;
                else {
                  delete I.attribs[G];
                  return;
                }
              } catch {
                delete I.attribs[G];
                return;
              }
            if (G === "class") {
              const X = R[C], Y = R["*"], ge = _[C], fe = O[C], le = O["*"], ft = _["*"], We = [
                ge,
                ft
              ].concat(fe, le).filter(function(dt) {
                return dt;
              });
              if (X && Y ? Q = we(Q, l(X, Y), We) : Q = we(Q, X || Y, We), !Q.length) {
                delete I.attribs[G];
                return;
              }
            }
            if (G === "style") {
              if (n.parseStyleAttributes)
                try {
                  const X = h(C + " {" + Q + "}", { map: !1 }), Y = xe(X, n.allowedStyles);
                  if (Q = Re(Y), Q.length === 0) {
                    delete I.attribs[G];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + C + " {" + Q + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete I.attribs[G];
                  return;
                }
              else if (n.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            g += " " + G, Q && Q.length ? g += '="' + ce(Q, !0) + '"' : n.allowedEmptyAttributes.includes(G) && (g += '=""');
          } else
            delete I.attribs[G];
        }), n.selfClosing.indexOf(C) !== -1 ? g += " />" : (g += ">", I.innerText && !ue && !n.textFilter && (g += ce(I.innerText), oe = !0)), H && (g = x + ce(g), x = ""), I.openingTagLength = g.length - I.tagPosition;
      },
      ontext: function(C) {
        if (ee)
          return;
        const L = V[V.length - 1];
        let I;
        if (L && (I = L.tag, C = L.innerText !== void 0 ? L.innerText : C), n.disallowedTagsMode === "completelyDiscard" && !w(I))
          C = "";
        else if ((n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && (I === "script" || I === "style"))
          g += C;
        else if (!oe) {
          const H = ce(C, !1);
          n.textFilter ? g += n.textFilter(H, I) : g += H;
        }
        if (V.length) {
          const H = V[V.length - 1];
          H.text += C;
        }
      },
      onclosetag: function(C, L) {
        if (n.onCloseTag && n.onCloseTag(C, L), ee)
          if (te--, !te)
            ee = !1;
          else
            return;
        const I = V.pop();
        if (!I)
          return;
        if (I.tag !== C) {
          V.push(I);
          return;
        }
        ee = n.enforceHtmlBoundary ? C === "html" : !1, N--;
        const H = z[N];
        if (H) {
          if (delete z[N], n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
            I.updateParentNodeText();
            return;
          }
          x = g, g = "";
        }
        if (J[N] && (C = J[N], delete J[N]), n.exclusiveFilter) {
          const ue = n.exclusiveFilter(I);
          if (ue === "excludeTag") {
            H && (g = x, x = ""), g = g.substring(0, I.tagPosition) + g.substring(I.tagPosition + I.openingTagLength);
            return;
          } else if (ue) {
            g = g.substring(0, I.tagPosition);
            return;
          }
        }
        if (I.updateParentNodeMediaChildren(), I.updateParentNodeText(), // Already output />
        n.selfClosing.indexOf(C) !== -1 || // Escaped tag, closing tag is implied
        L && !w(C) && ["escape", "recursiveEscape"].indexOf(n.disallowedTagsMode) >= 0) {
          H && (g = x, x = "");
          return;
        }
        g += "</" + C + ">", H && (g = x + ce(g), x = ""), oe = !1;
      }
    }, n.parser);
    return Ne.write(y), Ne.end(), g;
    function B() {
      g = "", N = 0, V = [], z = {}, J = {}, ee = !1, te = 0;
    }
    function ce(C, L) {
      return typeof C != "string" && (C = C + ""), n.parser.decodeEntities && (C = C.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), L && (C = C.replace(/"/g, "&quot;"))), C = C.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), L && (C = C.replace(/"/g, "&quot;")), C;
    }
    function ve(C, L) {
      for (L = L.replace(/[\x00-\x20]+/g, ""); ; ) {
        const ue = L.indexOf("<!--");
        if (ue === -1)
          break;
        const ne = L.indexOf("-->", ue + 4);
        if (ne === -1)
          break;
        L = L.substring(0, ue) + L.substring(ne + 3);
      }
      const I = L.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!I)
        return L.match(/^[/\\]{2}/) ? !n.allowProtocolRelative : !1;
      const H = I[1].toLowerCase();
      return i(n.allowedSchemesByTag, C) ? n.allowedSchemesByTag[C].indexOf(H) === -1 : !n.allowedSchemes || n.allowedSchemes.indexOf(H) === -1;
    }
    function Ce(C) {
      if (C = C.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), C.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let L = "relative://relative-site";
      for (let ue = 0; ue < 100; ue++)
        L += `/${ue}`;
      const I = new URL(C, L);
      return {
        isRelativeUrl: I && I.hostname === "relative-site" && I.protocol === "relative:",
        url: I
      };
    }
    function xe(C, L) {
      if (!L)
        return C;
      const I = C.nodes[0];
      let H;
      return L[I.selector] && L["*"] ? H = l(
        L[I.selector],
        L["*"]
      ) : H = L[I.selector] || L["*"], H && (C.nodes[0].nodes = I.nodes.reduce(De(H), [])), C;
    }
    function Re(C) {
      return C.nodes[0].nodes.reduce(function(L, I) {
        return L.push(
          `${I.prop}:${I.value}${I.important ? " !important" : ""}`
        ), L;
      }, []).join(";");
    }
    function De(C) {
      return function(L, I) {
        return i(C, I.prop) && C[I.prop].some(function(ue) {
          return ue.test(I.value);
        }) && L.push(I), L;
      };
    }
    function we(C, L, I) {
      return L ? (C = C.split(/\s+/), C.filter(function(H) {
        return L.indexOf(H) !== -1 || I.some(function(ue) {
          return ue.test(H);
        });
      }).join(" ")) : C;
    }
  }
  const b = {
    decodeEntities: !0
  };
  return o.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0,
    preserveEscapedAttributes: !1
  }, o.simpleTransform = function(y, n, m) {
    return m = m === void 0 ? !0 : m, n = n || {}, function(g, x) {
      let s;
      if (m)
        for (s in n)
          x[s] = n[s];
      else
        x = n;
      return {
        tagName: y,
        attribs: x
      };
    };
  }, Kt;
}
var qi = /* @__PURE__ */ Di();
const Li = /* @__PURE__ */ ui(qi), it = ({ value: u, as: E = "span", ...v }) => {
  const l = E, d = ti(() => u ? Li(u) : "", [u]);
  return /* @__PURE__ */ k.jsx(l, { dangerouslySetInnerHTML: { __html: d }, ...v });
}, Hr = ({ cents: u, locale: E, showCents: v = !1 }) => new Intl.NumberFormat(E, {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: v ? 2 : 0,
  maximumFractionDigits: v ? 2 : 0
}).format(u / 100), sn = ({
  project: u,
  locale: E = document.documentElement.lang || "de",
  href: v,
  onClick: l,
  className: d,
  showDescription: h,
  openInTab: a,
  bottomContent: f,
  children: p,
  showCarrierName: i
}) => {
  var m, g, x, s, w, S, A, P;
  const r = Hr({ cents: u.open_amount_in_cents, locale: E }), c = new Intl.NumberFormat(E).format(u.donations_count), e = E === "de" ? "fehlen noch" : "still needed", t = E === "de" ? "Spenden" : "donations", o = v || ((m = u.links.find((R) => R.rel === "platform")) == null ? void 0 : m.href), b = (x = (g = u.profile_picture) == null ? void 0 : g.links.find((R) => R.rel === "fill_410x214")) == null ? void 0 : x.href, y = (S = (w = (s = u.carrier) == null ? void 0 : s.picture) == null ? void 0 : w.links.find((R) => R.rel === "fill_100x100")) == null ? void 0 : S.href, n = (R) => {
    l && l(R, u);
  };
  return /* @__PURE__ */ k.jsxs(
    "a",
    {
      title: u.title,
      onClick: n,
      className: `donatable-teaser ${d ?? ""} ${h ? "donatable-teaser--with-description" : ""} ${f ? "donatable-teaser--with-bottom-content" : ""}`,
      href: o,
      target: a ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        p,
        /* @__PURE__ */ k.jsx(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${b})` },
            title: u.title
          }
        ),
        /* @__PURE__ */ k.jsx(it, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        h && /* @__PURE__ */ k.jsx(it, { className: "donatable-teaser--description", as: "div", value: u.description }),
        /* @__PURE__ */ k.jsxs("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ k.jsxs("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ k.jsxs("div", { children: [
              u.city && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
                /* @__PURE__ */ k.jsx("span", { children: u.city }),
                ",",
                " "
              ] }),
              u.country
            ] }),
            /* @__PURE__ */ k.jsx("div", { children: i ? /* @__PURE__ */ k.jsx("span", { children: (A = u.carrier) == null ? void 0 : A.name }) : /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
              /* @__PURE__ */ k.jsx("span", { children: c }),
              " ",
              t
            ] }) }),
            /* @__PURE__ */ k.jsxs("div", { children: [
              /* @__PURE__ */ k.jsx("span", { children: r }),
              " ",
              e
            ] })
          ] }),
          /* @__PURE__ */ k.jsx("img", { src: y, alt: (P = u.carrier) == null ? void 0 : P.name, className: "donatable-teaser--carrier-logo" })
        ] }),
        /* @__PURE__ */ k.jsx("div", { className: "donatable-teaser--progress", children: /* @__PURE__ */ k.jsx("div", { className: "donatable-teaser--progress-bar", style: { width: `${u.progress_percentage}%` } }) }),
        f
      ]
    }
  );
}, Mi = (u, E) => E === 1 ? u === "de" ? "Spende" : "donation" : u === "de" ? "Spenden" : "donations", on = ({
  fundraisingEvent: u,
  locale: E = document.documentElement.lang || "de",
  href: v,
  onClick: l,
  openInTab: d,
  children: h
}) => {
  var e, t, o, b, y, n, m, g;
  const a = v || ((e = u.links.find((x) => x.rel === "platform")) == null ? void 0 : e.href), f = (o = (t = u.profile_picture) == null ? void 0 : t.links.find(
    (x) => x.rel === "fill_410x214"
  )) == null ? void 0 : o.href, p = Hr({ cents: u.donated_amount_in_cents, locale: E }), i = (n = (y = (b = u.contact) == null ? void 0 : b.picture) == null ? void 0 : y.links.find((x) => x.rel === "fill_100x100")) == null ? void 0 : n.href, r = (x) => {
    l && l(x, u);
  }, c = Mi(E, u.donations_count);
  return /* @__PURE__ */ k.jsxs(
    "a",
    {
      title: u.title,
      onClick: r,
      className: "donatable-teaser",
      href: a,
      target: d ? "_blank" : "_parent",
      rel: "noreferrer",
      children: [
        h,
        /* @__PURE__ */ k.jsx(
          "div",
          {
            className: "donatable-teaser--profile-picture",
            style: { backgroundImage: `url(${f})` },
            title: u.title
          }
        ),
        /* @__PURE__ */ k.jsx(it, { as: "h2", className: "donatable-teaser--title", value: u.title }),
        /* @__PURE__ */ k.jsxs("div", { className: "donatable-teaser--divider", children: [
          /* @__PURE__ */ k.jsxs("div", { className: "donatable-teaser--factlist", children: [
            /* @__PURE__ */ k.jsx("div", { children: /* @__PURE__ */ k.jsx(it, { as: "span", value: (m = u.contact) == null ? void 0 : m.name }) }),
            /* @__PURE__ */ k.jsxs("div", { children: [
              /* @__PURE__ */ k.jsx("span", { children: u.donations_count }),
              " ",
              c
            ] }),
            /* @__PURE__ */ k.jsxs("div", { children: [
              /* @__PURE__ */ k.jsx("span", { children: p }),
              " ",
              E === "de" ? "gesammelt" : "collected"
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            "img",
            {
              style: { borderRadius: "50%", border: "1px solid #cccccc" },
              src: i,
              alt: ((g = u.contact) == null ? void 0 : g.name) ?? "",
              className: "donatable-teaser--carrier-logo"
            }
          )
        ] })
      ]
    }
  );
}, ki = ({
  icon: u,
  content: E,
  className: v = "",
  boxShadow: l,
  buttonClassName: d = "",
  ...h
}) => {
  const a = u;
  return /* @__PURE__ */ k.jsxs(
    "a",
    {
      ...h,
      className: `share-button--full ${l ? "share-button--box-shadowed" : ""} ${d} ${v}`,
      children: [
        /* @__PURE__ */ k.jsx("div", { className: "share-button--full-icon-wrapper", children: /* @__PURE__ */ k.jsx(a, { className: "share-button--icon" }) }),
        /* @__PURE__ */ k.jsx("span", { className: "share-button--text", children: E })
      ]
    }
  );
}, ji = ({
  icon: u,
  content: E,
  className: v = "",
  buttonClassName: l = "",
  boxShadow: d,
  ...h
}) => {
  const a = u;
  return /* @__PURE__ */ k.jsxs("a", { ...h, className: `share-button--minimal ${l} ${v}`, children: [
    /* @__PURE__ */ k.jsx(a, { className: "share-button--icon" }),
    /* @__PURE__ */ k.jsx("span", { className: "share-button--text", children: E })
  ] });
}, Bi = ({ icon: u, className: E = "", boxShadow: v, buttonClassName: l = "", ...d }) => {
  const h = u;
  return /* @__PURE__ */ k.jsx(
    "a",
    {
      ...d,
      className: `share-button--round ${v ? "share-button--box-shadowed" : ""} ${l} ${E}`,
      children: /* @__PURE__ */ k.jsx(h, {})
    }
  );
}, Ui = ({
  icon: u,
  className: E = "",
  buttonClassName: v = "",
  boxShadow: l,
  ...d
}) => {
  const h = u;
  return /* @__PURE__ */ k.jsx("a", { ...d, className: `share-button--square ${v} ${E}`, children: /* @__PURE__ */ k.jsx(h, {}) });
}, Hi = ({
  icon: u,
  content: E,
  className: v = "",
  boxShadow: l,
  buttonClassName: d = "",
  ...h
}) => {
  const a = u;
  return /* @__PURE__ */ k.jsxs("div", { className: `share-button--round-with-label ${v}`, children: [
    /* @__PURE__ */ k.jsx(
      "a",
      {
        ...h,
        className: `share-button--round ${l ? "share-button--box-shadowed" : ""} ${d}`,
        children: /* @__PURE__ */ k.jsx(a, {})
      }
    ),
    E
  ] });
}, Fi = {
  full: ki,
  minimal: ji,
  round: Bi,
  square: Ui,
  roundWithLabel: Hi
}, Be = ({
  action: u,
  ariaLabel: E,
  buttonLabel: v,
  className: l,
  icon: d
}) => (a) => {
  const f = Fi[a.shape], p = (i) => {
    i.preventDefault(), a.beforeOnClick && a.beforeOnClick(i), u(a);
  };
  return /* @__PURE__ */ k.jsx(
    f,
    {
      "aria-label": E,
      boxShadow: a.boxShadow,
      className: a.className || "",
      buttonClassName: l,
      href: "#",
      onClick: p,
      role: "button",
      title: a.title || "",
      label: v || E,
      icon: d,
      content: a.content
    }
  );
}, Vi = ({ size: u = "60%" }) => /* @__PURE__ */ k.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ k.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
      }
    )
  }
), zi = ({ size: u = "60%" }) => /* @__PURE__ */ k.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 512",
    children: /* @__PURE__ */ k.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
      }
    )
  }
), $i = ({ size: u = "60%" }) => /* @__PURE__ */ k.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ k.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"
      }
    )
  }
), Gi = ({ size: u = "60%" }) => /* @__PURE__ */ k.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ k.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
      }
    )
  }
), Wi = ({ size: u = "60%" }) => /* @__PURE__ */ k.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ k.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
      }
    )
  }
), Yi = ({ size: u = "60%" }) => /* @__PURE__ */ k.jsx(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    children: /* @__PURE__ */ k.jsxs("g", { children: [
      /* @__PURE__ */ k.jsx(
        "path",
        {
          fill: "currentColor",
          d: `M337.5,448c-5.7,0-11.4-1.7-16.4-5.2c-5.6-3.9-10.8-8.5-15.5-13.5l-19.3-20.6c-48.9-52.1-46.2-134.3,5.9-183.2l95-89.1
		c52.1-48.9,134.3-46.2,183.2,5.9c48.9,52.1,46.2,134.3-5.9,183.2l-31.8,29.8c-11.5,10.8-29.6,10.2-40.4-1.3
		c-10.8-11.5-10.2-29.6,1.3-40.4l31.8-29.8c29.2-27.3,30.7-73.3,3.3-102.5c-27.3-29.2-73.3-30.7-102.5-3.3l-95,89.1
		c-29.2,27.3-30.7,73.3-3.3,102.5l19.3,20.6c2,2.2,4.3,4.1,6.7,5.9c12.9,9.1,16,26.9,6.9,39.8C355.3,443.8,346.5,448,337.5,448z`
        }
      ),
      /* @__PURE__ */ k.jsx(
        "path",
        {
          fill: "currentColor",
          d: `M245.8,617.8c-34.6,0-69.1-13.7-94.6-40.9c-48.9-52.1-46.2-134.3,5.9-183.2l31.8-29.8c11.5-10.8,29.6-10.2,40.4,1.3
		c10.8,11.5,10.2,29.6-1.3,40.4l-31.8,29.8c-29.2,27.3-30.7,73.3-3.3,102.5c27.3,29.2,73.3,30.7,102.5,3.3l95-89.1
		c29.2-27.3,30.7-73.3,3.3-102.5L374.4,329c-2-2.2-4.3-4.1-6.7-5.9c-12.9-9.1-16-26.9-6.9-39.8c9.1-12.9,26.9-16,39.8-6.9
		c5.6,3.9,10.8,8.5,15.5,13.5l19.3,20.6c48.9,52.1,46.2,134.3-5.9,183.2l-95,89.1C309.5,606.3,277.6,617.8,245.8,617.8z`
        }
      )
    ] })
  }
), Ji = ({ size: u = "60%" }) => /* @__PURE__ */ k.jsxs(
  "svg",
  {
    className: "share-button--icon",
    width: u,
    height: u,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.486 40.912",
    children: [
      /* @__PURE__ */ k.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M95.09,109.768c.137-.971.242-1.947.417-2.911.991-5.459,4.855-9.173,10.381-9.364,6.654-.229,13.327-.241,19.98,0a10.692,10.692,0,0,1,10.558,10.687q.3,9.583,0,19.182a10.691,10.691,0,0,1-10.558,10.687c-6.653.24-13.328.246-19.98,0-6.016-.226-10.174-4.69-10.576-10.715-.035-.521-.147-1.038-.223-1.557Zm20.749,24.713c3.045,0,6.092.091,9.133-.021,4.767-.177,7.7-3.022,7.811-7.785q.207-8.9,0-17.812c-.111-4.762-3.046-7.673-7.811-7.775q-9.072-.192-18.151,0c-4.729.1-7.67,2.952-7.8,7.661q-.245,9.014,0,18.039c.128,4.709,3.069,7.5,7.8,7.671C109.823,134.572,112.832,134.482,115.839,134.482Zm0,0",
          transform: "translate(-95.09 -97.317)"
        }
      ),
      /* @__PURE__ */ k.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M184.564,174a10.572,10.572,0,1,0,10.572,10.571A10.572,10.572,0,0,0,184.564,174Zm0,17.5a6.932,6.932,0,1,1,6.932-6.932A6.932,6.932,0,0,1,184.564,191.5Zm0,0",
          transform: "translate(-163.821 -164.111)"
        }
      ),
      /* @__PURE__ */ k.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M328.315,153.258a2.515,2.515,0,1,1-2.515-2.515A2.515,2.515,0,0,1,328.315,153.258Zm0,0",
          transform: "translate(-293.868 -143.855)"
        }
      )
    ]
  }
);
function Xi(u) {
  return u.toLowerCase().startsWith("utm_");
}
const Qi = (u) => new URLSearchParams(Object.entries(u).filter(([v, l]) => l !== void 0)), ou = (u, E = {}) => {
  if (!u) return u;
  const v = u.startsWith("http") ? u : `https://${u}`, l = new URL(v);
  return l.searchParams.forEach((h, a, f) => {
    Xi(a) && f.delete(a);
  }), Qi(E).forEach((h, a) => l.searchParams.set(a, h)), l.toString();
}, Ge = (u, E = {}, v = "") => {
  const l = ou(u, E);
  return encodeURIComponent(v + l);
}, Fr = (u) => window.open(u, "sharer", "toolbar=no,width=1042,height=436"), Vr = (u) => {
  const E = document.createElement("textarea");
  E.value = u, document.body.appendChild(E), E.select();
  const v = document.execCommand("copy");
  if (document.body.removeChild(E), !v) {
    const d = (document.documentElement.lang || "de") === "de" ? "Sorry, dein Browser unterstützt diese Funktion nicht." : "Sorry, your Browser doesn't support this feature.";
    alert(d);
  }
  return v;
}, zr = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent), Zi = ({
  shareUrl: u,
  subject: E = null,
  teaser: v = "",
  utmParams: l
}) => {
  const d = encodeURIComponent(E || v), h = Ge(u, l, `${v} `);
  return window.open(`mailto:?subject=${d}&body=${h}`, "_self");
}, cn = Be({
  action: Zi,
  ariaLabel: "Email",
  className: "share-button--email",
  icon: Vi
}), Ki = ({ shareUrl: u, utmParams: E }) => Fr(`https://www.facebook.com/sharer/sharer.php?u=${Ge(u, E)}`), ln = Be({
  action: Ki,
  ariaLabel: "Facebook",
  className: "share-button--facebook",
  icon: zi
}), en = ({
  facebookAppId: u,
  shareUrl: E,
  utmParams: v
}) => {
  const l = zr(), d = Ge(E, v);
  return l ? window.open(`fb-messenger://share?link=${d}&app_id=${u}`) : Fr(
    `http://www.facebook.com/dialog/send?app_id=${u}&link=${d}&redirect_uri=${encodeURIComponent(E)}`
  );
}, fn = Be({
  action: en,
  ariaLabel: "Facebook Messenger",
  buttonLabel: "Messenger",
  className: "share-button--facebook-messenger",
  icon: $i
}), tn = ({ shareUrl: u, teaser: E = "", utmParams: v }) => window.open(
  `https://telegram.me/share/url?url=${Ge(u, v)}&text=${encodeURIComponent(E)}`
), dn = Be({
  action: tn,
  ariaLabel: "Telegram",
  className: "share-button--telegram",
  icon: Gi
}), un = ({ shareUrl: u, utmParams: E }) => window.open(
  `https://${zr() ? "api" : "web"}.whatsapp.com/send?text=${Ge(u, E)}`
), hn = Be({
  action: un,
  ariaLabel: "WhatsApp",
  className: "share-button--whatsapp",
  icon: Wi
}), rn = ({ shareUrl: u, utmParams: E }) => {
  Vr(ou(u, E));
}, pn = Be({
  action: rn,
  ariaLabel: "ShareLink",
  buttonLabel: "Link",
  className: "share-button--share-link",
  icon: Yi
}), nn = ({ shareUrl: u, utmParams: E }) => {
  Vr(ou(u, E));
}, bn = Be({
  action: nn,
  ariaLabel: "Instagram",
  className: "share-button--instagram",
  icon: Ji
}), mn = (u, E) => u.replace(
  /\w\w/g,
  (v) => ("0" + Math.min(255, Math.max(0, parseInt(v, 16) + E)).toString(16)).substr(-2)
);
export {
  cn as EmailButton,
  ln as FacebookButton,
  fn as FacebookMessengerButton,
  on as FundraisingEventTeaser,
  bn as InstagramButton,
  pn as LinkButton,
  sn as ProjectTeaser,
  dn as TelegramButton,
  hn as WhatsappButton,
  mn as changeBrightness,
  Zi as emailShareAction,
  Ge as encodeShareURL,
  en as facebookMessengerShareAction,
  Ki as facebookShareAction,
  Hr as formatAmount,
  ou as getShareURL,
  nn as instagramAction,
  rn as linkAction,
  Fr as openPopup,
  tn as telegramShareAction,
  un as whatsappShareAction
};
